import React, { useState, useEffect, useCallback, useRef } from 'react';
import './TimeKeeping.css';
import './../../App.css';
import 'react-calendar/dist/Calendar.css'; // Import default calendar stylesheet
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from 'axios';
import {token, domain, globalTimeFormat} from '../Security';
import 'react-tabs/style/react-tabs.css'; 
import * as XLSX from 'xlsx'; // Import all exports from xlsx library
import loadingSpinner from './../../assets/loading.gif';
import { useTable, useSortBy } from "react-table";
import { format } from 'date-fns';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import CloseIcon from "@mui/icons-material/Close";
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SummarizeIcon from '@mui/icons-material/Summarize';
import DetailsIcon from '@mui/icons-material/Details';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SearchIcon from '@mui/icons-material/Search';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import ChecklistIcon from '@mui/icons-material/Checklist';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const TimeKeeping = ({user, userAccess, isHideSideMenu}) => {
    const [showSetting, setShowSetting] = useState(false);
    const settingRef = useRef(null);
    const buttonRef = useRef(null); 

    const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
    const [loadingRequestProcess, setLoadingRequestProcess] = useState(false);
    // const [employees, setEmployees] = useState([]);
    const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
    const [selectedDTR, setSelectedDTR] = useState([]);
    const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs

    const [selectedTab, setSelectedTab] = useState(0);
    const [showSelectDataLogs, setShowSelectDataLogs] = useState(false);
    const [showRevertTimeForm, setShowRevertTimeForm] = useState(false);
    const [showProcessTimeForm, setShowProcessTimeForm] = useState(false);
    const [showPostTimeForm, setShowPostTimeForm] = useState(false);
    const [showDeleteAll, setShowDeleteAll] = useState(false);
    const [showUploadForm, setShowUploadForm] = useState(false);
    const [showUploadTamperedForm, setShowUploadTamperedForm] = useState(false);
    const [isGenerate, setIsGenerate] = useState(false);
    const [generateMessage, setGenerateMessage] = useState(false);
    const [isRevert, setIsRevert] = useState(false);
    const [isProcess, setIsProcess] = useState(false);
    const [isPost, setIsPost] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isUpload, setIsUpload] = useState(false);
    const [isSelectLogs, setIsSelectLogs] = useState(false);
    //logs
    const [dateFromLogs, setDateFromLogs] = useState("");
    const [dateToLogs, setDateToLogs] = useState("");
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [employeePersonalInformationIdLogs, setEmployeePersonalInformationIdLogs] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    // const [employeeInfoLogs, setEmployeeInfoLogs] = useState([]);
    const [deviceLogs, setDeviceLogs] = useState("");
    
    const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("");
    const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] = useState("2");
    const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] = useState("4");
    // const [dateFromLogs, setDateFromLogs] = useState("2022-07-01");
    // const [dateToLogs, setDateToLogs] = useState("2024-05-14");

    //filters
    const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
    const [filterPayTypeId, setFilterPayTypeId] = useState("");
    const [filterClassificationId, setFilterClassificationId] = useState("");
    const [currentFilterClassificationId, setCurrentFilterClassificationId] = useState("");
    const [filterLocationId, setFilterLocationId] = useState("");
    const [filterSectionId, setFilterSectionId] = useState("");
    const [filterEmployeeGroup1Id, setFilterEmployeeGroup1Id] = useState("");

    useEffect(() => {
        if(currentFilterClassificationId !== filterClassificationId){
            setCurrentFilterClassificationId(filterClassificationId)
            setFilterLocationId("")
            setFilterSectionId("")
            setFilterEmployeeGroup1Id("")
        }
    }, [currentFilterClassificationId, filterClassificationId])

    const [filterClassificationIdTimeEntries, setFilterClassificationIdTimeEntries] = useState("0");
    
    const [sectionFilter, setSectionFilter] = useState("0");
    const [locationFilter, setLocationFilter] = useState("0");
    
    const [filterData, setFilterData] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    const [showRequestWarningMessage, setShowRequestWarningMessage] = useState(false);
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [showRequestMessage]);
    useEffect(() => {
        if (showRequestWarningMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestWarningMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [showRequestWarningMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    function GenerateWarningMessage({form, message}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                    <div className="modal toggleMessage warning-message" style={{backgroundColor: "#ffd0c5"}}>
                        <div className='column'>
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"WARNING MESSAGE"}</span>
                            </div>
                            <span style={{textAlign:"center", padding:"10px 0", color: "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleSelectChange = (index) => {
        setSelectedTab(index);
    };
    const handleSetting = () =>{
        setShowSetting(!showSetting);
    };
    const handleGenerate = () => {
        if (!filterPayrollPeriodId || !filterPayTypeId || !filterClassificationId) {
            setGenerateMessage(true);
            return;
        }
            
        setIsGenerate(true);
    };

    const handleSelectDataLogs_main = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);
        
        const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/select-logs`;

        let classifiedData = classificationFilterForAdminHRHead;

        const data = {
            dateFrom: dateFromLogs,
            dateTo: dateToLogs,
            classificationId: classifiedData
        };

        try {
            console.log("Sending POST request");  // Added logging
            await axios.post(apiUrlUserTimeLog, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            });
            setShowSelectDataLogs(false);
            // deleteBulk(event);

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "Select Data Logs", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchDataTimeEntries();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            
            // Detailed error logging
            if (error.response) {
                // The request was made and the server responded with a status code outside of the 2xx range
                console.error('Error response:', error.response);
                console.error('Error response data:', error.response.data);
                const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
                setRequestMessage(errorMessage);
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Error request:', error.request);
                setRequestMessage("No response received from the server.");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error message:', error.message);
                setRequestMessage("An error occurred while processing your request.");
            }
        }

        setLoadingRequest(false);
        setShowSelectDataLogs(false);
    };
    const handleSelectDataLogs = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);

        const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/user-time-log-raw`;

        let classifiedData = classificationFilterForAdminHRHead;

        const data = {
            dateFrom: dateFromLogs,
            dateTo: dateToLogs,
            classificationId: classifiedData
        };

        try {
            console.log("Sending POST request");  // Added logging
            await axios.post(apiUrlUserTimeLog, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            });
            setShowSelectDataLogs(false);
            // deleteBulk(event);

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "Select Data Logs", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchDataTimeEntries();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            
            // Detailed error logging
            if (error.response) {
                // The request was made and the server responded with a status code outside of the 2xx range
                console.error('Error response:', error.response);
                console.error('Error response data:', error.response.data);
                const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
                setRequestMessage(errorMessage);
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Error request:', error.request);
                setRequestMessage("No response received from the server.");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error message:', error.message);
                setRequestMessage("An error occurred while processing your request.");
            }
        }

        setLoadingRequest(false);
        setShowSelectDataLogs(false);
    };
    const handleSelectDataLogs_Mobile = async (event) => {
        event.preventDefault();

        setLoadingRequest(true);

        const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/mobile-dtr`;

        let classifiedData = classificationFilterForAdminHRHead;

        const data = {
            dateFrom: dateFromLogs,
            dateTo: dateToLogs,
            classificationId: classifiedData
        };

        try {
            console.log("Sending POST request");  // Added logging
            await axios.post(apiUrlUserTimeLog, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            });
            setShowSelectDataLogs(false);
            // deleteBulk(event);

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "Select Data Logs", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchDataTimeEntries();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            
            // Detailed error logging
            if (error.response) {
                // The request was made and the server responded with a status code outside of the 2xx range
                console.error('Error response:', error.response);
                console.error('Error response data:', error.response.data);
                const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
                setRequestMessage(errorMessage);
            } else if (error.request) {
                // The request was made but no response was received
                console.error('Error request:', error.request);
                setRequestMessage("No response received from the server.");
            } else {
                // Something happened in setting up the request that triggered an Error
                console.error('Error message:', error.message);
                setRequestMessage("An error occurred while processing your request.");
            }
        }

        setLoadingRequest(false);
        setShowSelectDataLogs(false);
    };

    const handleDeleteAll = async (event) => {
        event.preventDefault();
        const apiUrl = domain + `/api/EmployeeTimeRecord`;
        setLoadingRequest(true);
        closeDeleteAll();

        if(dateTimeRecordData.length === 0){
            setLoadingRequest(false);
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No record to delete");
            closeDeleteAll();
            return;
        }
        
        try {
            console.log("Sending POST request");  // Added logging
            await axios.post(apiUrl + `/bulk-delete`, dateTimeRecordData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
            });
    
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "delete", 
                field: "Delete All Uploaded Time Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchDataTimeEntries();

            setIsDelete(true);
            closeDeleteAll();
        } catch (error) {
            setLoadingRequest(false);
            console.error('Error:', error);
        } finally {
            setLoadingRequest(false);
        }

        setIsDelete(true);
    }
    useEffect(() => {
        if (generateMessage) {
            const timeoutId = setTimeout(() => {
                setGenerateMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [generateMessage]);
    useEffect(() => {
        var settingIcon = document.getElementById("setting-icon");

        if(showSetting){
            //change the down icon to up
            settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
        } else {
            //change the up icon to down
            settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
            settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
        }

        const handleClickOutside = (event) => {
            if (settingRef.current && !settingRef.current.contains(event.target)) {
                if(buttonRef.current && !buttonRef.current.contains(event.target)){
                    setShowSetting(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };


    }, [showSetting]);

    const [isGenerateUploadedTimeEntries, setIsGenerateUploadedTimeEntries] = useState(false);
    const [payrollPeriodUploadedTimeEntries, setPayrollPeriodUploadedTimeEntries] = useState("");
    const generateUploadedTimeEntries = () => {
        setIsGenerateUploadedTimeEntries(true);
    }

    //====================================================================================================
    //===============================TIME ENTRIES=========================================================
    //====================================================================================================
    // const [isSetEmployeesOnce, setIsSetEmployeesOnce] = useState(false);
    const [showTampered, setShowTampered] = useState(false);
    const fetchDataTimeEntries = useCallback(async () => {
        if(!isGenerateUploadedTimeEntries){
            return;
        }

        let classificationFilter = filterClassificationIdTimeEntries;
        
        // const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}`;
        const apiUrlFetch =  domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}/payrollperiod/${payrollPeriodUploadedTimeEntries}`;

        try {
            setLoadingRequest(true);
            const response = await axios.get(apiUrlFetch, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

            setIsRevert(false);
            setIsProcess(false);
            setIsPost(false);
            setIsDelete(false);
            setIsUpload(false);
            setIsSelectLogs(false);

            setDateTimeRecordData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoadingRequest(false);
        } finally {
            setLoadingRequest(false); // Set loading state to false after data fetching is complete
        }
    }, [
        filterClassificationIdTimeEntries,
        sectionFilter,
        locationFilter,
        isGenerateUploadedTimeEntries,
        payrollPeriodUploadedTimeEntries
    ]);
    //====================================================================================================
    //===============================TIME ENTRIES=========================================================
    //====================================================================================================

    //====================================================================================================
    //===============================PROCESSED TIME ENTRIES===============================================
    //====================================================================================================
    const [loadingSummaryProcessed, setLoadingSummaryProcessed] = useState(false);
    const [loadingDetailedProcessed, setLoadingDetailedProcessed] = useState(false);
    const [filterDataSummaryProcessed, setFilterDataSummaryProcessed] = useState([]);
    const [filterDataDetailedProcessed, setFilterDataDetailedProcessed] = useState([]);
    const [dateTimeRecordDataSummaryProcessed, setDateTimeRecordDataSummaryProcessed] = useState([]);
    const [dateTimeRecordDataDetailedProcessed, setDateTimeRecordDataDetailedProcessed] = useState([]);

    const fetchDataSummaryProcessed = useCallback(async () => {
        const apiUrlStaging =  domain + "/api/DateTimeRecordStaging";

        if(!isGenerate) return;
        
        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingSummaryProcessed(true);

            const response = await axios.get(apiUrlStaging + `/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/employeeGroup1/${filterEmployeeGroup1Id ? filterEmployeeGroup1Id : 0}/summary`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setDateTimeRecordDataSummaryProcessed(response.data); // Set the response data to the state
                setFilterDataSummaryProcessed(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingSummaryProcessed(false); // Set loading state to false after data fetching is complete
        }
        
    }, [filterClassificationId, filterPayTypeId, filterPayrollPeriodId, filterLocationId, filterSectionId, filterEmployeeGroup1Id,isGenerate]);
    const fetchDataDetailedProcessed = useCallback(async () => {
        const apiUrlStaging =  domain + "/api/DateTimeRecordStaging";

        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingDetailedProcessed(true);
            const response = await axios.get(apiUrlStaging + `/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/employeeGroup1/${filterEmployeeGroup1Id ? filterEmployeeGroup1Id : 0}/detailed`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            console.log(response.data)
                setDateTimeRecordDataDetailedProcessed(response.data); // Set the response data to the state
                setFilterDataDetailedProcessed(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingDetailedProcessed(false); // Set loading state to false after data fetching is complete
        }
    
    }, [filterClassificationId, filterPayTypeId, filterPayrollPeriodId, filterLocationId, filterSectionId, filterEmployeeGroup1Id, isGenerate]);
    //====================================================================================================
    //===============================PROCESSED TIME ENTRIES===============================================
    //====================================================================================================

    //====================================================================================================
    //===============================POSTED TIME ENTRIES==================================================
    //====================================================================================================
    const [loadingSummaryPosted, setLoadingSummaryPosted] = useState(false);
    const [loadingDetailedPosted, setLoadingDetailedPosted] = useState(false);
    const [filterDataSummaryPosted, setFilterDataSummaryPosted] = useState([]);
    const [filterDataDetailedPosted, setFilterDataDetailedPosted] = useState([]);
    const [dateTimeRecordDataSummaryPosted, setDateTimeRecordDataSummaryPosted] = useState([]);
    const [dateTimeRecordDataDetailedPosted, setDateTimeRecordDataDetailedPosted] = useState([]);

    const fetchDataSummaryPosted = useCallback(async () => {
        const apiUrl =  domain + "/api/DateTimeRecord";

        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }

        try {
            setLoadingSummaryPosted(true);
            const response = await axios.get(apiUrl + `/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/employeeGroup1/${filterEmployeeGroup1Id ? filterEmployeeGroup1Id : 0}/summary`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setDateTimeRecordDataSummaryPosted(response.data); // Set the response data to the state
                setFilterDataSummaryPosted(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingSummaryPosted(false); // Set loading state to false after data fetching is complete
        }
    }, [filterClassificationId, filterPayTypeId, filterPayrollPeriodId, filterLocationId, filterSectionId, filterEmployeeGroup1Id, isGenerate]);
    const fetchDataDetailedPosted = useCallback(async () => {
        const apiUrl =  domain + "/api/DateTimeRecord";

        if(!isGenerate) return;

        let classifiedData = filterClassificationId;

        if(!filterPayTypeId || !filterPayrollPeriodId || !classifiedData){ return; }
        try {
            setLoadingDetailedPosted(true);
            const response = await axios.get(apiUrl + `/paytype/${filterPayTypeId}/payrollperiod/${filterPayrollPeriodId}/classification/${classifiedData}/location/${filterLocationId ? filterLocationId : 0}/section/${filterSectionId ? filterSectionId : 0}/employeeGroup1/${filterEmployeeGroup1Id ? filterEmployeeGroup1Id : 0}/detailed`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setDateTimeRecordDataDetailedPosted(response.data); // Set the response data to the state
                setFilterDataDetailedPosted(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoadingDetailedPosted(false); // Set loading state to false after data fetching is complete
        }
    }, [filterClassificationId, filterPayTypeId, filterPayrollPeriodId, filterLocationId, filterSectionId, filterEmployeeGroup1Id, isGenerate]);
    //====================================================================================================
    //===============================POSTED TIME ENTRIES==================================================
    //====================================================================================================

    const openSelectDataLogs = () =>{
        setShowSelectDataLogs(true);
    }
    const closeSelectDataLogs = () =>{
        setShowSelectDataLogs(false);
    }
    const openRevertTimeForm = () =>{
        setShowRevertTimeForm(true);
    }
    const closeRevertTimeForm = () =>{
        setShowRevertTimeForm(false);
    }
    const openProcessTimeForm = () =>{
        setShowProcessTimeForm(true);
    }
    const closeProcessTimeForm = () =>{
        setShowProcessTimeForm(false);
    }
    const openPostTimeForm = () =>{
        setShowPostTimeForm(true);
    }
    const closePostTimeForm = () =>{
        setShowPostTimeForm(false);
    }
    const openDeleteAll = () =>{
        setShowDeleteAll(true);
    }
    const closeDeleteAll = () =>{
        setShowDeleteAll(false);
    }
    const openUploadFormHandleClick  = () =>{
        setShowUploadForm(true);
    }
    const closeUploadFormHandleClick = () =>{
        setShowUploadForm(false);
    }
    const openUploadTamperedFormHandleClick  = () =>{
        setShowUploadTamperedForm(true);
    }
    const closeUploadTamperedFormHandleClick = () =>{
        setShowUploadTamperedForm(false);
    }
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };
    /* const underMaintenance = () =>{
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("This is under maintenance");
    } */

    //settings buttons
    const generateDownloadTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'EmployeeId', 
            'EmployeeName', 
            'Date', 
            'TimeIn', 
            'DeviceNameIn', 
            'TimeOut', 
            'DeviceNameOut'
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'deviceNameTimeIn', width: 30 },
            { key: 'timeOut', width: 20 },
            { key: 'deviceNameTimeOut', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        worksheet.addRow(['<EMP1234>', '<LastName, FirstName>', '<MM/DD/YYYY>', '<hh:mm AM/PM>',  '<Device1>', '<hh:mm AM/PM>',  '<Device1>']);

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'DTRTemplate.xlsx');
    };
    /* const s2ab = s => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }; */

    /* const [errorData, setErrorData] = useState([]);
    const [errorTamperedData, setErrorTamperedData] = useState([]);
    const [isErrorUpload, setIsErrorUpload] = useState(false);
    const [isErrorTamperedUpload, setIsErrorTamperedUpload] = useState(false); */
    const fetchAllEmployees = async () => {
        const apiUrl =  domain + "/api/Employee/single-data";
        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };
    
    /* function parseExcelFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
        
            reader.onload = (e) => {
                try {
                    const binaryString = e.target.result;
                    const workbook = XLSX.read(binaryString, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    
                    // Get all rows except the first one (header row)
                    const excelData = XLSX.utils.sheet_to_json(sheet, {
                        header: [
                        'employeePersonalInformationEmployeeId', 
                        'employeePersonalInformationFullName', 
                        'date', 
                        'timeIn', 
                        "deviceNameTimeIn", 
                        "timeOut", 
                        "deviceNameTimeOut"
                    ],
                        range: 1, 
                        defval: "" 
                    });

                    excelData.forEach(row => {
                        if (typeof row.date === 'number') {
                            const excelDate = row.date;
                            const date = new Date((excelDate - (25567 + 1)) * 86400 * 1000);
                            row.date = date.toLocaleDateString();
                        }
                        if (typeof row.timeIn === 'number') {
                            const excelTime = row.timeIn;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeInMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeInMilliseconds);
                            row.timeIn = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                        if (typeof row.timeOut === 'number') {
                            const excelTime = row.timeOut;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeOutMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeOutMilliseconds);
                            row.timeOut = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                    });
                    
                    resolve(excelData);
                } catch (error) {
                    reject(error);
                }
            };
        
            reader.readAsBinaryString(file);
        });
    }
    function parseTamperedExcelFile(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
        
            reader.onload = (e) => {
                try {
                    const binaryString = e.target.result;
                    const workbook = XLSX.read(binaryString, { type: 'binary' });
                    const sheetName = workbook.SheetNames[0];
                    const sheet = workbook.Sheets[sheetName];
                    
                    // Get all rows except the first one (header row)
                    const excelData = XLSX.utils.sheet_to_json(sheet, {
                        header: [
                        'id',
                        'employeePersonalInformationEmployeeId', 
                        'employeePersonalInformationFullName', 
                        'date', 
                        'timeIn', 
                        'deviceNameTimeIn', 
                        'timeOut', 
                        'deviceNameTimeOut',
                        'shiftName',
                        'reasonForTampering'
                    ],
                        range: 1, // Skip the first row (header row)
                        defval: "" // Include empty cells
                    });

                    excelData.forEach(row => {
                        if (typeof row.date === 'number') {
                            const excelDate = row.date;
                            const date = new Date((excelDate - (25567 + 1)) * 86400 * 1000);
                            row.date = date.toLocaleDateString();
                        }
                        if (typeof row.timeIn === 'number') {
                            const excelTime = row.timeIn;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeInMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeInMilliseconds);
                            row.timeIn = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                        if (typeof row.timeOut === 'number') {
                            const excelTime = row.timeOut;
                            const millisecondsInDay = 24 * 60 * 60 * 1000;
                            const timeOutMilliseconds = excelTime * millisecondsInDay;
                            const date = new Date(timeOutMilliseconds);
                            row.timeOut = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' }); // Format time as desired
                        }
                    });
                    
                    resolve(excelData);
                } catch (error) {
                    reject(error);
                }
            };
        
            reader.readAsBinaryString(file);
        });
    }
    function combineDateTimeToLocal(date, time) {
        // Split date and time
        const [month, day, year] = date.split('/');
        const [timeWithoutAMPM, ampm] = time.split(' ');

        // Extract hours and minutes
        const [hours, minutes] = timeWithoutAMPM.split(':').map(Number);

        // Convert hours to 24-hour format if PM
        let adjustedHours = hours;
        if (ampm === 'PM' && hours !== 12) {
            adjustedHours += 12;
        } else if (ampm === 'AM' && hours === 12) {
            adjustedHours = 0;
        }

        // Combine date and time into datetime-local format
        const datetimeLocal = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${adjustedHours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

        return datetimeLocal;
    }
    function isValidTimeFormat(time) {
        // Regular expression for the time format hh:mm AM/PM
        const timeRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(?:AM|PM)$/i;
    
        // Test if the time matches the regular expression
        return timeRegex.test(time);
    }
    function isValidDateFormat(date) {
        // Regex allows single or double-digit MM/DD
        const dateRegex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
    
        return dateRegex.test(date);
    }
    const downloadError = useCallback((entries) => {
        const allData = [];
        
        entries.forEach(entry => {
            const data = [
                [entry.employeePersonalInformationEmployeeId, 
                    entry.employeePersonalInformationFullName, 
                    entry.date, 
                    entry.timeIn, 
                    entry.deviceNameTimeIn, 
                    entry.timeOut, 
                    entry.deviceNameTimeOut, 
                    entry.error]
            ];

            allData.push(...data);
        });

        allData.unshift(['EmployeeId', 'EmployeeName', 'Date', 'TimeIn', 'Device', 'TimeOut', 'Device', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []);
    const downloadTamperedError = useCallback((entries) => {
        const allData = [];
        
        entries.forEach(entry => {
            const data = [
                [
                    entry.id,
                    entry.employeePersonalInformationEmployeeId, 
                    entry.employeePersonalInformationFullName, 
                    entry.date, 
                    entry.timeIn, 
                    entry.deviceNameTimeIn, 
                    entry.timeOut, 
                    entry.deviceNameTimeOut, 
                    entry.shiftName, 
                    entry.reasonForTampering,
                    entry.error
                ]
            ];

            allData.push(...data);
        });

        allData.unshift(['Id','EmployeeId', 'EmployeeName', 'Date', 'TimeIn', 'Device', 'TimeOut', 'Device', 'Shift Name', 'Reason For Tampering', 'Error(NOTE: Please delete this column if you want to re-use this worksheet)']);

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet(allData);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'RegularDataSheet');

        const excelBuffer = XLSX.write(workbook, { type: 'binary', bookType: 'xlsx' });

        const blob = new Blob([s2ab(excelBuffer)], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'ErrorTamperedFile.xlsx';
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, []); */

    const convertToDateTime = (value) => {
        if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
            return null;
        }

        if(!value){
            return null;
        }

        if (typeof value === 'number') {
            // Convert Excel serial number to JavaScript Date
            const excelStartDate = new Date(1899, 11, 31); // Correct base date
            const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds
            
            return jsDate.toISOString().split('T')[0];
        }

        if (typeof value === 'string') {
            let formattedValue = value.replace(/-/g, '/'); // Ensure compatibility
            
            const parts = formattedValue.split('/');
            if (parts.length === 3) {
                let [first, second, third] = parts.map(p => parseInt(p, 10));
    
                let year, month, day;
    
                if (third > 31) {
                    // Case: YYYY/MM/DD (Ensure proper year detection)
                    year = third;
                    month = first;
                    day = second;
                } else if (first > 12) {
                    // Case: DD/MM/YYYY (Auto-detect)
                    day = first;
                    month = second;
                    year = third;
                } else {
                    // Case: MM/DD/YYYY (US format)
                    month = first;
                    day = second;
                    year = third;
                }
    
                return new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0]; // Return YYYY-MM-DD
            }
        }

        return null
    }
    const convertToTime = (value, date, timeIn = null) => {
        if (
            value === null ||
            value === undefined ||
            value === '' ||
            (
                typeof value === 'string' &&
                value.startsWith('<') &&
                value.endsWith('>')
            )
        ) {
            return null;
        }

        let hour;
        let minute;

        if (typeof value === 'number') {
            const totalMilliseconds = value * 86400000;

            hour = Math.floor(
                (totalMilliseconds % 86400000) / 3600000
            );

            minute = Math.floor(
                (totalMilliseconds % 3600000) / 60000
            );
        }

        if (typeof value === 'string') {
            const timeMatch = value.match(
                /(\d{1,2}):(\d{2})\s?(AM|PM)?/i
            );

            if (timeMatch) {
                hour = parseInt(timeMatch[1], 10);
                minute = parseInt(timeMatch[2], 10);

                const period = timeMatch[3]?.toUpperCase();

                if (period === 'PM' && hour !== 12) {
                    hour += 12;
                }

                if (period === 'AM' && hour === 12) {
                    hour = 0;
                }
            }
        }

        if (hour === undefined || minute === undefined) {
            return null;
        }

        // Start with the original date
        let resultDate = new Date(`${date}T00:00:00`);

        // Check if TimeOut crosses midnight
        if (timeIn) {
            const timeInDate = new Date(timeIn);

            const timeInMinutes =
                timeInDate.getHours() * 60 +
                timeInDate.getMinutes();

            const timeOutMinutes =
                hour * 60 +
                minute;

            if (timeOutMinutes < timeInMinutes) {
                resultDate.setDate(resultDate.getDate() + 1);
            }
        }

        const year = resultDate.getFullYear();
        const month = String(resultDate.getMonth() + 1).padStart(2, '0');
        const day = String(resultDate.getDate()).padStart(2, '0');

        const formattedTime =
            `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

        return `${year}-${month}-${day}T${formattedTime}`;
    };

    const [uploadTimeEntries, setUploadTimeEntries] = useState([]);
    const uploadTimeEntriesFunc = async (file) => {
        setLoadingUploadRequest(true);
        const employees = await fetchAllEmployees();

        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                if (!item.employeePersonalInformationEmployeeId) missing.push('Employee Id');
                if (!item.date) missing.push('Date');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = employees.find(employee => {
                    return employee.employeeId?.toString() === item.employeePersonalInformationEmployeeId?.toString()
                });
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];

            informations.forEach(info => {
                const date = convertToDateTime(info.Date);

                const existingEmployee = employees.find(employee => employee.employeeId === info.EmployeeId?.toString());

                // Convert Time In first
                const timeIn = convertToTime(
                    info.TimeIn,
                    date
                );

                // Pass Time In to Time Out so it can detect midnight crossing
                const timeOut = convertToTime(
                    info.TimeOut,
                    date,
                    timeIn
                );

                bulkData.push({
                    employeePersonalInformationId: existingEmployee
                        ? existingEmployee.id
                        : null,

                    // Keep the original Excel Employee ID
                    employeePersonalInformationEmployeeId:
                        sanitizeValue(info.EmployeeId).toString(),

                    employeePersonalInformationFullName:
                        sanitizeValue(info.EmployeeName),

                    date: date,

                    timeIn: timeIn,

                    deviceNameTimeIn:
                        sanitizeValue(info.DeviceNameIn),

                    timeOut: timeOut,

                    deviceNameTimeOut:
                        sanitizeValue(info.DeviceNameOut),

                    createdDate: new Date()
                });
            });

            const validatedData = validateData(bulkData)
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            setUploadTimeEntries(sortedData)
        };

        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    }
    const handleFileUpload= async (files) => {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }
        
        const file = files[0];
        uploadTimeEntriesFunc(file);
        /* 
        setLoadingRequest(true);

        const employees = await fetchAllEmployees();

        let finalData = [];
        
        parseExcelFile(file)
        .then(async (data) => {
            let isError = false;
            setLoadingRequest(false);

            data.forEach((entry) => {
                let errorMsg = "";
                for (let i = 0; i < Object.keys(entry).length; i++) {
                    const header = Object.keys(entry)[i];
                    const values = Object.values(entry)[i];
                    
                    if(values === null 
                        || values === undefined
                        || values === ""
                    ){
                        if(header !== "deviceNameTimeIn" 
                        && header !== "deviceNameTimeOut" 
                        && header !== "timeIn" 
                        && header !== "timeOut" 
                        ) {
                            errorMsg = "Has an empty value. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "employeePersonalInformationEmployeeId"){
                        const foundEmployee = employees.find(employee => employee.employeeId.toString() === values.toString());
                        if(!foundEmployee){
                            errorMsg = errorMsg + "Invalid employee id. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "date"){
                        if(!isValidDateFormat(values) && values){
                            errorMsg = errorMsg + "Date should be mm/dd/yyyy format. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "timeIn" || header === "timeOut"){
                        if(!isValidTimeFormat(values) && values){
                            errorMsg = errorMsg + "Time should be hh:mm AM/PM format. ";
                            setIsErrorUpload(true);
                            isError = true;
                        }
                    }
                }

                const newErrorData = {
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId,
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName,
                    date: isValidDateFormat(entry.date) ? entry.date : entry.date,
                    timeIn: isValidTimeFormat(entry.timeIn) ? entry.timeIn : entry.timeIn,
                    deviceNameTimeIn: entry.deviceNameTimeIn,
                    timeOut: isValidTimeFormat(entry.timeOut) ? entry.timeOut : entry.timeOut,
                    deviceNameTimeOut: entry.deviceNameTimeOut,
                    error: errorMsg 
                };

                setErrorData(prevErrorData => [...prevErrorData, newErrorData]);
            });

            if(isError) {
                return;
            }

            data.forEach((entry) => {
                const foundEmployee = employees.find(employee => employee.employeeId.toString() === entry.employeePersonalInformationEmployeeId.toString());

                const _data = {
                    employeePersonalInformationId: foundEmployee.id, 
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId.toString(), 
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName, 
                    date: entry.date ? combineDateTimeToLocal(entry.date, "00:00 AM") : null, 
                    timeIn: entry.timeIn ? combineDateTimeToLocal(entry.date, entry.timeIn) : null, 
                    deviceNameTimeIn: entry.deviceNameTimeIn, 
                    timeOut: entry.timeOut ? combineDateTimeToLocal(entry.date, entry.timeOut) : null, 
                    deviceNameTimeOut: entry.deviceNameTimeOut,
                    createdDate: new Date()
                };

                finalData.push(_data);
            });


            console.log('Final bulkData:', JSON.stringify(finalData, null, 2));

            const apiUrl =  domain + "/api/EmployeeTimeRecord/bulk";

            try {
                axios.post(apiUrl, finalData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })
            
                await SetAuditTrail({
                    setupArea: "Time Entries", 
                    actionTaken: "insert", 
                    field: "Upload Time Entries", 
                    newValue: "-", 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });

                setTimeout(async () => {
                    await fetchDataTimeEntries();
                    await fetchDataSummaryPosted();
                    await fetchDataDetailedPosted();
                }, 1000);

                
                setShowRequestMessage(true);
                setIsSuccess(true);
                setIsUpload(true);
                setIsErrorUpload(false);
                setErrorData([]);
            } catch (error) {
                console.error('Error posting data to API:', error);
                setShowRequestMessage(true);
                setIsSuccess(false);
                
                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                    setRequestMessage(errorMessage);
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message; // Fallback to general message
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred."); // Default message
                }
            }
        })
        .catch((error) => {
            setLoadingRequest(false);
            console.error('Error parsing Excel file:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                setRequestMessage(errorMessage);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message; // Fallback to general message
                setRequestMessage(errorMessage);
            } else {
                setRequestMessage("An unknown error occurred."); // Default message
            }
        }); */
    }
    const handleFinalFileUpload = async (bulkData) => {
        setLoadingRequest(true);
    
        const apiUrl =  domain + "/api/EmployeeTimeRecord/bulk";

        try {
            axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })
        
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "Upload Time Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            setTimeout(async () => {
                await fetchDataTimeEntries();
                await fetchDataSummaryPosted();
                await fetchDataDetailedPosted();
            }, 1000);
            
            setShowRequestMessage(true);
            setIsSuccess(true);
            setIsUpload(true);
        } catch (error) {
            console.error('Error posting data to API:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                setRequestMessage(errorMessage);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message; // Fallback to general message
                setRequestMessage(errorMessage);
            } else {
                setRequestMessage("An unknown error occurred."); // Default message
            }
        } finally{
            setLoadingRequest(false);
        }
    }

    const [uploadTamperedEntries, setUploadTamperedEntries] = useState([]);

    const uploadTamperedFunc = async (file) => {
        setLoadingUploadRequest(true);
        const employees = await fetchAllEmployees();

        function sanitizeValue(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return '';
            }
            return value;
        }
        function sanitizeValueNull(value) {
            if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
                return null;
            }
            return value;
        }
        function validateData(data) {
            let newData = [];
        
            data.forEach((item, index) => {
                const missing = [];
                
                // if (!item.id) missing.push('Id');
                if (!item.employeePersonalInformationEmployeeId) missing.push('Employee Id');
                if (!item.date) missing.push('Date');
                // if (!item.reasonForTampering) missing.push('Reason For Tampering');
        
                // ✅ Construct error message properly
                let errorMessage = "";

                const existingEmployee = employees.find(employee => {
                    // console.log(employee.employeeId?.toString(), item.employeePersonalInformationEmployeeId?.toString())
                    return employee.employeeId?.toString() === item.employeePersonalInformationEmployeeId?.toString()
                });
                if (!existingEmployee) {
                    errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
                }

                // const existindId = dateTimeRecordData.find(dtr => dtr.id?.toString() === item.id?.toString());
                // if (!existindId) {
                //     errorMessage += errorMessage.length > 0 ? ` Id does not exist.` : `Id does not exist. `;
                // }
        
                if (missing.length > 0) {
                    errorMessage += ` Missing fields - ${missing.join(', ')}`;
                }
        
                newData.push({ ...item, errors: errorMessage });
            });
            
            newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

            return newData;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
    
            const parseWorksheet = (worksheet) => {
                return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            };
    
            const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

            let bulkData = [];

            informations.forEach(info => {
                const date = convertToDateTime(info.Date);

                const timeIn = convertToTime(info.TimeIn, date);

                const timeOut = convertToTime(
                    info.TimeOut,
                    date,
                    timeIn
                );

                bulkData.push({
                    id: sanitizeValueNull(info.Id),
                    employeePersonalInformationEmployeeId: sanitizeValue(info.EmployeeId).toString(),
                    employeePersonalInformationFullName: sanitizeValue(info.Name),

                    date: date,

                    timeIn: timeIn,
                    deviceNameTimeIn: sanitizeValue(info.DeviceIn),

                    timeOut: timeOut,
                    deviceNameTimeOut: sanitizeValue(info.DeviceOut),

                    employeePersonalInformationEmployeeInformationShiftScheduleShiftName:
                        sanitizeValue(info.ShiftName),

                    reasonForTampering: sanitizeValue(info.ReasonForTampering)
                });
            });

            const validatedData = validateData(bulkData)
            const sortedData = validatedData.sort((a, b) => {
                const hasErrorA = a.errors && a.errors.length > 0;
                const hasErrorB = b.errors && b.errors.length > 0;
            
                return hasErrorB - hasErrorA; // Move items with errors to the top
            });
            setUploadTamperedEntries(sortedData)
        };

        setLoadingUploadRequest(false);
        reader.readAsArrayBuffer(file);
    } 
    const handleFileUploadTampered = async (files) => {
        if (!files || files.length === 0) {
            console.error('No files selected');
            return;
        }
        
        const file = files[0];
        uploadTamperedFunc(file);
        /* setLoadingRequest(true);
        
        const employees = await fetchAllEmployees();

        let finalData = [];

        //original data ===========
        const originalData = [
            [
                'Id',
                'Employee Id',
                'Name',
                'Date',
                'Time In',
                'Device In',
                'Time Out',
                'Device Out',
                'Shift Name',
                'Reason For Tampering'
            ]
        ];
        dateTimeRecordData.forEach(item => {
            const filteredItem = {
                id: item.id,
                employeePersonalInformationEmployeeId: item.employeePersonalInformationEmployeeId,
                employeePersonalInformationFullName: item.employeePersonalInformationFullName,
                date: item.date,
                timeIn: item.timeIn,
                deviceNameTimeIn: item.deviceNameTimeIn,
                timeOut: item.timeOut,
                deviceNameTimeOut: item.deviceNameTimeOut,
                employeePersonalInformationEmployeeInformationShiftScheduleShiftName: item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName,
                reasonForTampering: item.reasonForTampering
            };
        
            const row = Object.entries(filteredItem).map(([key, value]) => {
                if (key === 'date') {
                    const datetime = new Date(value);
        
                    const month = datetime.getMonth() + 1;
                    const day = datetime.getDate();
                    const year = datetime.getFullYear();
        
                    return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;
                }

                if (key === 'timeIn' || key === 'timeOut') {
                    // Ensure value is not null or undefined before splitting
                    if (value != null) {
                        // Split the time string to extract hour and minute components
                        const timePart = value.split('T')[1];
                        if (timePart) {
                            const [hour, minute] = timePart.split(':'); // Extracts hour and minute parts
            
                            const hours = parseInt(hour);
                            const ampm = hours >= 12 ? 'PM' : 'AM';
                            const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour clock
            
                            // Format the time as HH:MM AM/PM
                            return `${formattedHours}:${minute} ${ampm}`;
                        }
                    }
                }
                
                return value;
            });
            originalData.push(row);
        });
        //=========================
        
        parseTamperedExcelFile(file)
        .then(async (data) => {
            let isError = false;
            setLoadingRequest(false);

            data.forEach((entry) => {
                let errorMsg = "";
                for (let i = 0; i < Object.keys(entry).length; i++) {
                    const header = Object.keys(entry)[i];
                    const values = Object.values(entry)[i];

                    const foundData = originalData.find(origData => origData[0] ===  Object.values(entry)[0]);

                    if(foundData){
                        if(values && values !== foundData[i]){
                            const reasonValue = Object.values(entry)[9]
                            if(reasonValue === null 
                                || reasonValue === undefined
                                || reasonValue === ""
                            ){
                                errorMsg = "(Tampered) Need Reason for Tampering. ";
                                setIsErrorTamperedUpload(true);
                                isError = true;
                            }
                        }
                    }
                    
                    if(values === null 
                        || values === undefined
                        || values === ""
                    ){
                        if(header !== "reasonForTampering"
                        && header !== "deviceNameTimeIn" 
                        && header !== "deviceNameTimeOut" 
                        && header !== "timeIn" 
                        && header !== "timeOut" 
                        ){
                            errorMsg = "Has an empty value. ";
                            setIsErrorTamperedUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "id"){
                        const foundEmployee = dateTimeRecordData.find(employee => employee.id.toString() === values.toString());
                        if(!foundEmployee){
                            errorMsg = errorMsg + "Invalid entry id. ";
                            setIsErrorTamperedUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "employeePersonalInformationEmployeeId"){
                        const foundEmployee = employees.find(employee => employee.employeeId.toString() === values.toString());
                        if(!foundEmployee){
                            errorMsg = errorMsg + "Invalid employee id. ";
                            setIsErrorTamperedUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "date"){
                        if(!isValidDateFormat(values)  && values){
                            errorMsg = errorMsg + "Date should be mm/dd/yyyy format. ";
                            setIsErrorTamperedUpload(true);
                            isError = true;
                        }
                    }

                    if(header === "timeIn" || header === "timeOut"){
                        if(!isValidTimeFormat(values) && values){
                            errorMsg = errorMsg + "Time should be hh:mm AM/PM format. ";
                            setIsErrorTamperedUpload(true);
                            isError = true;
                        }
                    }
                }

                const newErrorData = {
                    id: entry.id,
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId,
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName,
                    date: isValidDateFormat(entry.date) ? entry.date : entry.date,
                    timeIn: isValidTimeFormat(entry.timeIn) ? entry.timeIn : entry.timeIn,
                    deviceNameTimeIn: entry.deviceNameTimeIn,
                    timeOut: isValidTimeFormat(entry.timeOut) ? entry.timeOut : entry.timeOut,
                    deviceNameTimeOut: entry.deviceNameTimeOut,
                    shiftName: entry.shiftName,
                    reasonForTampering: entry.reasonForTampering,
                    error: errorMsg 
                };

                setErrorTamperedData(prevErrorData => [...prevErrorData, newErrorData]);
            });

            if(isError) {
                return;
            }

            const currentDate = new Date();

            data.forEach((entry) => {
                const _data = {
                    id: entry.id, 
                    employeePersonalInformationEmployeeId: entry.employeePersonalInformationEmployeeId.toString(), 
                    employeePersonalInformationFullName: entry.employeePersonalInformationFullName, 
                    date: entry.date ? combineDateTimeToLocal(entry.date, "00:00 AM") : null, 
                    timeIn: entry.timeIn ? combineDateTimeToLocal(entry.date, entry.timeIn) : null, 
                    deviceNameTimeIn: entry.deviceNameTimeIn, 
                    timeOut: entry.timeOut ? combineDateTimeToLocal(entry.date, entry.timeOut) : null, 
                    deviceNameTimeOut: entry.deviceNameTimeOut, 
                    updatedById: user.id,
                    updatedDate: currentDate,
                    shiftName: entry.shiftName,
                    reasonForTampering: entry.reasonForTampering,
                };
                
                finalData.push(_data);
            });
        
            const apiUrl =  domain + "/api/EmployeeTimeRecord/bulk-update-tampering";

            // console.log('Final bulkData:', JSON.stringify(finalData, null, 2));

            try {
                axios.post(apiUrl, finalData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                })

                await SetAuditTrail({
                    setupArea: "Time Entries", 
                    actionTaken: "insert", 
                    field: "Upload Tampered Entries", 
                    newValue: "-", 
                    oldValue: "-", 
                    dateSaved: new Date(), 
                    savedById: user.id
                });

                await fetchDataTimeEntries();

                setShowRequestMessage(true);
                setIsSuccess(true);
                setIsUpload(true);
                setIsErrorTamperedUpload(false);
                setErrorTamperedData([]);
            } catch (error) {
                console.error('Error posting data to API:', error);
                setShowRequestMessage(true);
                setIsSuccess(false);
                
                if (error.response && error.response.data && error.response.data.errors) {
                    const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                    setRequestMessage(errorMessage);
                } else if (error.response && error.response.data && error.response.data.message) {
                    const errorMessage = error.response.data.message; // Fallback to general message
                    setRequestMessage(errorMessage);
                } else {
                    setRequestMessage("An unknown error occurred."); // Default message
                }
            }
        })
        .catch((error) => {
            setLoadingRequest(true);
            console.error('Error parsing Excel file:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                setRequestMessage(errorMessage);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message; // Fallback to general message
                setRequestMessage(errorMessage);
            } else {
                setRequestMessage("An unknown error occurred."); // Default message
            }
        }); */
    }
    const handleFinalFileUploadTampered = async (bulkData) => {
        setLoadingRequest(true);
    
        const apiUrl =  domain + "/api/EmployeeTimeRecord/bulk-update-tampering";

        try {
            axios.post(apiUrl, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            })

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "Upload Tampered Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchDataTimeEntries();

            setShowRequestMessage(true);
            setIsSuccess(true);
            setIsUpload(true);
        } catch (error) {
            console.error('Error posting data to API:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            
            if (error.response && error.response.data && error.response.data.errors) {
                const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
                setRequestMessage(errorMessage);
            } else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message; // Fallback to general message
                setRequestMessage(errorMessage);
            } else {
                setRequestMessage("An unknown error occurred."); // Default message
            }
        } finally{
            setLoadingRequest(false);
        }
    }
    
    /* useEffect(() => {
        if(isErrorUpload){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage('Please check the ErrorFile.xlsx');
            setIsUpload(false);
            setIsErrorUpload(false);
            setErrorData([]);
            downloadError(errorData);
        }

        if(isErrorTamperedUpload){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage('Please check the ErrorTamperedFile.xlsx');
            setIsUpload(false);
            setIsErrorTamperedUpload(false);
            setErrorTamperedData([]);
            downloadTamperedError(errorTamperedData);
        }
    }, [isErrorUpload, isErrorTamperedUpload, downloadError, downloadTamperedError, errorData, errorTamperedData]); */

    const [currentFilterPayTypeIdPayTypeId, setCurrentFilterPayTypeIdPayTypeId] = useState("");
    useEffect(() => {
        if(currentFilterPayTypeIdPayTypeId !== filterPayTypeId){
            setCurrentFilterPayTypeIdPayTypeId(filterPayTypeId);
            setFilterClassificationId("");
            setFilterPayrollPeriodId("");
        }
    }, [currentFilterPayTypeIdPayTypeId, filterPayTypeId])

    return(
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="TimeInfo shadow-xl">
                        <div className='sub-title row' style={{padding:"5px 20px"}}>
                            <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Time Keeping >"} </span>
                            <span style={{borderBottom:"1px solid black"}}>{"Time Entries"}</span>
                        </div>
                        <div className="timeHeader row" style={{justifyContent:"space-between", alignItems:"center"}}>
                            <div className="tHeaderTitle row">
                                <AccessTimeFilledIcon style={{padding:"0 10px 0 0"}}/>
                                <h3>Time Entries</h3>
                            </div>
                            <div style={{width:"30%",textAlign:"right"}}>
                                <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                                    <SettingsIcon/>
                                    <KeyboardArrowDownIcon id="setting-icon"/>
                                </button>
                                <div ref={settingRef}>
                                    {showSetting && 
                                        <SettingInit
                                        user={user}
                                        generateDownloadTemplate={generateDownloadTemplate}
                                        openSelectDataLogs={openSelectDataLogs}
                                        // openSelectDataLogs={underMaintenance}
                                        openRevertTimeForm={openRevertTimeForm}
                                        openProcessTimeForm={openProcessTimeForm}
                                        openPostTimeForm={openPostTimeForm}
                                        openDeleteAll={openDeleteAll}
                                        openUploadFormHandleClick={openUploadFormHandleClick}
                                        />}
                                </div>
                                
                            </div>
                        </div>
                        <div className="mainData">
                            <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}
                                    style={{display: 
                                        userAccess.description === "Accounting"
                                        || userAccess.description === "Accounting Head"
                                        || userAccess.description === "Accounting Assistant" ?
                                        "none" : "block"
                            }}>
                                <TabList>
                                    <Tab><b>UPLOAD TIME ENTRIES</b></Tab>
                                    <Tab><b>PROCESSED TIME ENTRIES</b></Tab>
                                    <Tab><b>POSTED TIME ENTRIES</b></Tab>
                                </TabList>
                                <div className="timeKeepingTab">
                                    <TabPanel>
                                        <UploadTimeEntries
                                        dateTimeRecordData={dateTimeRecordData} 
                                        setDateTimeRecordData={setDateTimeRecordData}
                                        // employees={employees}
                                        isRevert={isRevert}
                                        isProcess={isProcess}
                                        isPost={isPost}
                                        isDelete={isDelete}
                                        isUpload={isUpload}
                                        setIsRevert={setIsRevert}
                                        setIsProcess={setIsProcess}
                                        setIsPost={setIsPost}
                                        setIsDelete={setIsDelete}
                                        setIsUpload={setIsUpload}
                                        selectedDTR={selectedDTR}
                                        setSelectedDTR={setSelectedDTR}
                                        activeRowIds={activeRowIds} 
                                        setActiveRowIds={setActiveRowIds}
                                        openUploadTamperedFormHandleClick={openUploadTamperedFormHandleClick}
                                        isSelectLogs={isSelectLogs}
                                        setIsSelectLogs={setIsSelectLogs}
                                        userAccess={userAccess}
                                        user={user}
                                        filterData={filterData}
                                        fetchData={fetchDataTimeEntries}
                                        sectionFilter={sectionFilter}
                                        setSectionFilter={setSectionFilter}
                                        locationFilter={locationFilter}
                                        setLocationFilter={setLocationFilter}
                                        filterClassificationId={filterClassificationIdTimeEntries}
                                        setFilterClassificationId={setFilterClassificationIdTimeEntries}
                                        showTampered={showTampered} 
                                        setShowTampered={setShowTampered}

                                        payrollPeriodUploadedTimeEntries={payrollPeriodUploadedTimeEntries}
                                        setPayrollPeriodUploadedTimeEntries={setPayrollPeriodUploadedTimeEntries}
                                        generateUploadedTimeEntries={generateUploadedTimeEntries}
                                        />
                                    </TabPanel>
                                    <TabPanel>
                                        <div style={{padding:"10px"}}>
                                            <div className='filters-payroll'>
                                                <span>Filter</span>
                                                <div className="payroll-item-holder info-item-holder row" style={{ justifyContent: "normal", padding: "0 10px 20px 10px"}}>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Pay Type</div>
                                                        <div className="info-item-input">
                                                            <PayTypeIdSelect payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Payroll Period</div>
                                                        <div className="info-item-input">
                                                            <PayrollPeriodIdSelectFilter payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    { userAccess.length <= 0 &&
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Classification Type</div>
                                                            <div className="info-item-input">
                                                                <ClassificationIdSelectDummy/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    }
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Classification Type</div>
                                                        <div className="info-item-input">
                                                            <ClassificationIdSelectFilter user={user} classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                </div>
                                                { filterClassificationId.toString() === "2" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                { filterClassificationId.toString() === "3" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent: "normal", padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Section</div>
                                                            <div className="info-item-input">
                                                                <SectionIdSelect sectionId={filterSectionId} setSectionId={setFilterSectionId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                
                                                { filterClassificationId.toString() === "4" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent: "normal", padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Employee Group 1</div>
                                                            <div className="info-item-input">
                                                                <EmployeeGroup1IdSelect employeeGroup1Id={filterEmployeeGroup1Id} setEmployeeGroup1Id={setFilterEmployeeGroup1Id}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                                            </div>
                                        </div>
                                        <ProcessedTimeEntries
                                            filterPayrollPeriodId={filterPayrollPeriodId}
                                            filterPayTypeId={filterPayTypeId}
                                            filterClassificationId={filterClassificationId}
                                            filterLocationId={filterLocationId}
                                            filterSectionId={filterSectionId}
                                            userAccess={userAccess}
                                            isGenerate={isGenerate}
                                            isRevert={isRevert}
                                            isProcess={isProcess}
                                            isPost={isPost}
                                            loadingSummary={loadingSummaryProcessed}
                                            loadingDetailed={loadingDetailedProcessed}
                                            fetchDataSummary={fetchDataSummaryProcessed}
                                            fetchDataDetailed={fetchDataDetailedProcessed}
                                            filterDataSummary={filterDataSummaryProcessed}
                                            filterDataDetailed={filterDataDetailedProcessed}
                                            dateTimeRecordDataSummary={dateTimeRecordDataSummaryProcessed}
                                            setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryProcessed}
                                            dateTimeRecordDataDetailed={dateTimeRecordDataDetailedProcessed}
                                            setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedProcessed}
                                        />
                                    </TabPanel>
                                    <TabPanel>
                                        <div style={{padding:"10px"}}>
                                            <div className='filters-payroll'>
                                                <span>Filter</span>
                                                <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"normal", padding: "0 10px 20px 10px"}}>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Pay Type</div>
                                                        <div className="info-item-input">
                                                            <PayTypeIdSelect payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Payroll Period</div>
                                                        <div className="info-item-input">
                                                            <PayrollPeriodIdSelectFilter payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    { userAccess.length <= 0 &&
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Classification Type</div>
                                                            <div className="info-item-input">
                                                                <ClassificationIdSelectDummy/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    }
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Classification Type</div>
                                                        <div className="info-item-input">
                                                            <ClassificationIdSelectFilter user={user} classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                </div>
                                                { filterClassificationId.toString() === "2" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                { filterClassificationId.toString() === "3" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent: "normal", padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Section</div>
                                                            <div className="info-item-input">
                                                                <SectionIdSelect sectionId={filterSectionId} setSectionId={setFilterSectionId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                { filterClassificationId.toString() === "4" &&
                                                    <div className="payroll-item-holder info-item-holder row" style={{justifyContent: "normal", padding: "0 10px 20px 10px"}}>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Employee Group 1</div>
                                                            <div className="info-item-input">
                                                                <EmployeeGroup1IdSelect employeeGroup1Id={filterEmployeeGroup1Id} setEmployeeGroup1Id={setFilterEmployeeGroup1Id}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Location</div>
                                                            <div className="info-item-input">
                                                                <LocationIdSelect locationId={filterLocationId} setLocationId={setFilterLocationId}/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    </div>
                                                }
                                                <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                                            </div>
                                        </div>
                                        <PostedTimeEntries
                                            filterPayrollPeriodId={filterPayrollPeriodId}
                                            filterPayTypeId={filterPayTypeId}
                                            filterClassificationId={filterClassificationId}
                                            filterLocationId={filterLocationId}
                                            filterSectionId={filterSectionId}
                                            userAccess={userAccess}
                                            isGenerate={isGenerate}
                                            isRevert={isRevert}
                                            isProcess={isProcess}
                                            isPost={isPost}
                                            fetchDataSummary={fetchDataSummaryPosted}
                                            fetchDataDetailed={fetchDataDetailedPosted}
                                            filterDataSummary={filterDataSummaryPosted}
                                            filterDataDetailed={filterDataDetailedPosted}
                                            loadingSummary={loadingSummaryPosted}
                                            loadingDetailed={loadingDetailedPosted}
                                            dateTimeRecordDataSummary={dateTimeRecordDataSummaryPosted}
                                            setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryPosted}
                                            dateTimeRecordDataDetailed={dateTimeRecordDataDetailedPosted}
                                            setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedPosted}
                                        />
                                    </TabPanel>
                                </div>
                            </Tabs>

                            { (userAccess.description === "Accounting"
                            || userAccess.description === "Accounting Head"
                            || userAccess.description === "Accounting Assistant") &&
                                <div>
                                    <b style={{color: "#668fca"}}>POSTED TIME ENTRIES</b>
                                    <div style={{padding:"10px"}}>
                                            <div className='filters-payroll'>
                                                <span>Filter</span>
                                                <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"space-evenly", padding: "0 10px 20px 10px"}}>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Pay Type</div>
                                                        <div className="info-item-input">
                                                            <PayTypeIdSelect payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Payroll Period</div>
                                                        <div className="info-item-input">
                                                            <PayrollPeriodIdSelectFilter payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                    { userAccess.length <= 0 &&
                                                        <div className="filter-item-payroll popUp-item info-item column">
                                                            <div className="info-item-label">Classification Type</div>
                                                            <div className="info-item-input">
                                                                <ClassificationIdSelectDummy/>
                                                            </div>
                                                            <span style={{
                                                                visibility: "hidden",
                                                                color:"#ff6565", 
                                                                fontSize:"12px"}}>Please fill up Pay Type first
                                                            </span>
                                                        </div>
                                                    }
                                                    <div className="filter-item-payroll popUp-item info-item column">
                                                        <div className="info-item-label">Classification Type</div>
                                                        <div className="info-item-input">
                                                            <ClassificationIdSelectFilter user={user} classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} payTypeId={filterPayTypeId}/>
                                                        </div>
                                                        <span style={{
                                                            visibility: !filterPayTypeId ? "visible" : "hidden",
                                                            color:"#ff6565", 
                                                            fontSize:"12px"}}>Please fill up Pay Type first
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                                            </div>
                                    </div>
                                    <PostedTimeEntries
                                        filterPayrollPeriodId={filterPayrollPeriodId}
                                        filterPayTypeId={filterPayTypeId}
                                        filterClassificationId={filterClassificationId}
                                        userAccess={userAccess}
                                        isGenerate={isGenerate}
                                        isRevert={isRevert}
                                        isProcess={isProcess}
                                        isPost={isPost}
                                        fetchDataSummary={fetchDataSummaryPosted}
                                        fetchDataDetailed={fetchDataDetailedPosted}
                                        filterDataSummary={filterDataSummaryPosted}
                                        filterDataDetailed={filterDataDetailedPosted}
                                        loadingSummary={loadingSummaryPosted}
                                        loadingDetailed={loadingDetailedPosted}
                                        dateTimeRecordDataSummary={dateTimeRecordDataSummaryPosted}
                                        setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryPosted}
                                        dateTimeRecordDataDetailed={dateTimeRecordDataDetailedPosted}
                                        setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedPosted}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            
            <SelectLogsForm  isOpen={showSelectDataLogs} 
                    onClose={closeSelectDataLogs}
                    dateFromLogs={dateFromLogs}
                    setDateFromLogs={setDateFromLogs}
                    dateToLogs={dateToLogs}
                    setDateToLogs={setDateToLogs}
                    employeePersonalInformationId={employeePersonalInformationIdLogs}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationIdLogs}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    deviceLogs={deviceLogs}
                    setDeviceLogs={setDeviceLogs}
                    setShowEmployeeForm={setShowEmployeeForm}
                    classificationFilterForAdminHRHead={classificationFilterForAdminHRHead}
                    setClassificationFilterForAdminHRHead={setClassificationFilterForAdminHRHead}
                    classificationFilterForHRAsst2={classificationFilterForHRAsst2}
                    setClassificationFilterForHRAsst2={setClassificationFilterForHRAsst2}
                    classificationFilterForHRAsst3={classificationFilterForHRAsst3}
                    setClassificationFilterForHRAsst3={setClassificationFilterForHRAsst3}
                    handleSelectDataLogs={handleSelectDataLogs}
                    handleSelectDataLogs_Mobile={handleSelectDataLogs_Mobile}
                    handleSelectDataLogs_main={handleSelectDataLogs_main}
                    userAccessData={userAccess}
                    user={user}
            >
            </SelectLogsForm>
            <RevertTimeEntriesForm  isOpen={showRevertTimeForm} 
                    onClose={closeRevertTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchProcessedSummary={fetchDataSummaryProcessed}
                    fetchProcessedDetailed={fetchDataDetailedProcessed}
                    fetchPostedSummary={fetchDataSummaryPosted}
                    fetchPostedDetailed={fetchDataDetailedPosted}
                    setIsRevert={setIsRevert}
                    user={user}

                    loadingRequest={loadingRequestProcess}
                    setLoadingRequest={setLoadingRequestProcess}
                    loadingPercentage={loadingPercentage}
                    setLoadingPercentage={setLoadingPercentage}
            >
            </RevertTimeEntriesForm>
            <ProcessTimeEntriesForm  isOpen={showProcessTimeForm} 
                    onClose={closeProcessTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchProcessedSummary={fetchDataSummaryProcessed}
                    fetchProcessedDetailed={fetchDataDetailedProcessed}
                    fetchPostedSummary={fetchDataSummaryPosted}
                    fetchPostedDetailed={fetchDataDetailedPosted}
                    setIsProcess={setIsProcess}
                    user={user}

                    loadingRequest={loadingRequestProcess}
                    setLoadingRequest={setLoadingRequestProcess}
                    loadingPercentage={loadingPercentage}
                    setLoadingPercentage={setLoadingPercentage}
            >
            </ProcessTimeEntriesForm>
            <PostTimeEntriesForm  isOpen={showPostTimeForm} 
                    onClose={closePostTimeForm}
                    fetchUploads={fetchDataTimeEntries}
                    fetchProcessedSummary={fetchDataSummaryProcessed}
                    fetchProcessedDetailed={fetchDataDetailedProcessed}
                    fetchPostedSummary={fetchDataSummaryPosted}
                    fetchPostedDetailed={fetchDataDetailedPosted}
                    setIsPost={setIsPost}
                    user={user}

                    loadingRequest={loadingRequestProcess}
                    setLoadingRequest={setLoadingRequestProcess}
                    loadingPercentage={loadingPercentage}
                    setLoadingPercentage={setLoadingPercentage}
            >
            </PostTimeEntriesForm>
            <DeleteAllForm  isOpen={showDeleteAll} 
                    onClose={closeDeleteAll}
                    handleDelete={handleDeleteAll}
            >
            </DeleteAllForm>
            <UploadForm  isOpen={showUploadForm} 
                    onClose={closeUploadFormHandleClick}
                    data_temp={uploadTimeEntries}
                    setData_temp={setUploadTimeEntries}
                    handleFileUpload={handleFileUpload}
                    handleFinalFileUpload={handleFinalFileUpload}
            >
            </UploadForm>
            <UploadFormTampered  isOpen={showUploadTamperedForm} 
                    onClose={closeUploadTamperedFormHandleClick}
                    data_temp={uploadTamperedEntries}
                    setData_temp={setUploadTamperedEntries}
                    handleFileUpload={handleFileUploadTampered}
                    handleFinalFileUpload={handleFinalFileUploadTampered}
            >
            </UploadFormTampered>
            <EmployeeSelectFormLogs  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationIdLogs}
                    setEmployee={setEmployeePersonalInformationFullName}
                    // setEmployeeInfo={setEmployeeInfoLogs}
            >
            </EmployeeSelectFormLogs>
            <GenerateMessage form={generateMessage}
                    message={"Please select payroll period, pay type and classification type!"}
                    isSuccess={false}
            > 
            </GenerateMessage>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateWarningMessage form={showRequestWarningMessage}
                    message={"requestWarningMessage"}
            > 
            </GenerateWarningMessage>
            {loadingRequest && !loadingRequestProcess ?
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
                :
                <></>
            }
            { loadingRequestProcess &&
                <CustomLoader loadingPercentage={loadingPercentage}/>
            }
            
            {loadingUploadRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
    
}

function UploadTimeEntries({
    dateTimeRecordData,
    setDateTimeRecordData,
    setFetchUploads,
    employees,
    isRevert,
    isProcess,
    isPost,
    isDelete,
    isUpload,
    setIsRevert,
    setIsProcess,
    setIsPost,
    setIsDelete,
    setIsUpload,
    selectedDTR,
    setSelectedDTR,
    activeRowIds, 
    setActiveRowIds,
    openUploadTamperedFormHandleClick,
    isSelectLogs,
    setIsSelectLogs,
    userAccess,
    user,
    filterData,
    fetchData,
    sectionFilter,
    setSectionFilter,
    locationFilter,
    setLocationFilter,
    loading,
    filterClassificationId,
    setFilterClassificationId,
    showTampered,
    setShowTampered,

    payrollPeriodUploadedTimeEntries,
    setPayrollPeriodUploadedTimeEntries,
    generateUploadedTimeEntries
}){
    var uploadTimeEntriesHeader = [
        "Id",
        "Employee Id",
        "Employee",
        "Classification",
        "Date",
        "Time In",
        "Device",
        "Time Out",
        "Device",
        "Shift Name",
        "Reason for Tampering",
        "Approved?",
        "",
    ]
    var uploadTimeEntriesaccessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOut",
        "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
        "reasonForTampering",
        "isApproved",
        "manage"
    ]

    const [approveMessage, setApproveMessage] = useState(false);
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationEmployeeId, setEmployeePersonalInformationEmployeeId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [date, setDate] = useState("");
    const [timeIn, setTimeIn] = useState("");
    const [deviceNameTimeIn, setDeviceNameTimeIn] = useState("");
    const [timeOut, setTimeOut] = useState("");
    const [deviceNameTimeOut, setDeviceNameTimeOut] = useState("");
    const [reasonForTampering, setReasonForTampering] = useState("");
    //Old
    const [oldTimeIn, setOldTimeIn] = useState("");
    const [oldDeviceNameTimeIn, setOldDeviceNameTimeIn] = useState("");
    const [oldTimeOut, setOldTimeOut] = useState("");
    const [oldDeviceNameTimeOut, setOldDeviceNameTimeOut] = useState("");
    const [oldReasonForTampering, setOldReasonForTampering] = useState("");
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [dataToEdit, setDataToEdit] = useState([]);
    // Delete
    const [showDeleteForm, setShowDeleteForm] = useState(false);
    const [dataToDelete, setDataToDelete] = useState([]);
    //Approve
    const [showApproveForm, setShowApproveForm] = useState(false);
    const [isSelectAll, setIsSelectAll] = useState(false);

    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const handleClickShowTampered = () =>{
        if(dateTimeRecordData.length <= 0){
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No Time Entries yet.");
            return;
        }

        setShowTampered(!showTampered);
    }

    const apiUrl =  domain + "/api/EmployeeTimeRecord";

    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeePersonalInformationEmployeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setDateTimeRecordData(res);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            date: timeIn.split('T')[0],
            createdById: user.id,
            createdDate: new Date(),
        };

        try {
            setShowAddForm(false); // Hide the add form
            setLoadingRequest(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "inser", 
                field: "Add", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeePersonalInformationId("");
            setEmployeePersonalInformationFullName("");
            setTimeIn("");
            setDeviceNameTimeIn("");
            setTimeOut("");
            setDeviceNameTimeOut("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            employeePersonalInformationId: employeePersonalInformationId,
            employeePersonalInformationEmployeeId: employeePersonalInformationEmployeeId,
            date: date,
            timeIn: timeIn,
            deviceNameTimeIn: deviceNameTimeIn,
            timeOut: timeOut,
            deviceNameTimeOut: deviceNameTimeOut,
            reasonForTampering: reasonForTampering,
            createdById: dataToEdit.createdById,
            createdDate: dataToEdit.createdDate,
            updatedById: user.id,
            updatedDate: new Date()
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${dataToEdit.id}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            let auditInfo = [];

            if(data.timeIn !== oldTimeIn){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Time In",
                    newValue: `${data.timeIn}`,
                    oldValue: `${oldTimeIn}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.deviceNameTimeIn !== oldDeviceNameTimeIn){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Device Time In",
                    newValue: `${data.deviceNameTimeIn}`,
                    oldValue: `${oldDeviceNameTimeIn}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.timeOut !== oldTimeOut){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Time Out",
                    newValue: `${data.timeOut}`,
                    oldValue: `${oldTimeOut}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.deviceNameTimeOut !== oldDeviceNameTimeOut){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Device Time Out",
                    newValue: `${data.deviceNameTimeOut}`,
                    oldValue: `${oldDeviceNameTimeOut}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }
            if(data.reasonForTampering !== oldReasonForTampering){
                auditInfo.push({
                    setupArea: "Time Entries",
                    actionTaken: "update",
                    field: "Reason for Tampering",
                    newValue: `${data.reasonForTampering}`,
                    oldValue: `${oldReasonForTampering}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            setShowEditForm(false); // Hide the add form
            await SetAuditTrailBulk({data: auditInfo});
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };
    const handleDelete = async () => {
        try {
            setLoadingRequest(true);
            await axios.delete(apiUrl + `/${dataToDelete.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowDeleteForm(false);
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "delete", 
                field: "Delete Time Entry", 
                newValue: `-`, 
                oldValue: `${dataToDelete.employeePersonalInformationFullName}`, 
                dateSaved: new Date(), 
                savedById: user.id
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Deleted successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        
            // Reload table data and reset state
            setDataToDelete("");
        } catch (error) {
            console.error('There was a problem deleting employee:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
        
        setShowDeleteForm(false);
    };
    const approveHandleClick = async () => {
        if (selectedDTR.length <= 0) {
            setApproveMessage(true);
            setRequestMessage("No selected record");
            setIsSuccess(false);
            closeApproveHandleClick();
            return;
        }

        let finalData = []
        selectedDTR.forEach(data => {
            const dataToUpdate = {
                id: data.id,
                employeePersonalInformationId: data.employeePersonalInformationId,
                employeePersonalInformationEmployeeId: data.employeePersonalInformationEmployeeId,
                date: data.date,
                timeIn: data.timeIn,
                deviceCodeTimeIn: data.deviceCodeTimeIn,
                deviceNameTimeIn: data.deviceNameTimeIn,
                timeOut: data.timeOut,
                deviceCodeTimeOut: data.deviceCodeTimeOut,
                deviceNameTimeOut: data.deviceNameTimeOut,
                reasonForTampering: data.reasonForTampering,
                isApproved: true,
                approvedById: user.id,
                approvedDate: new Date(),
                createdById: data.createdById,
                createdDate: data.createdDate,
                updatedById: data.updatedById,
                updatedDate: data.updatedDate
            };

            finalData.push(dataToUpdate)
        })
        
        setLoadingRequest(true);
        setShowApproveForm(false);

        try {
            await axios.put(apiUrl + `/approval-bulk`, finalData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Updated successfully');

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "update", 
                field: "Approve", 
                newValue: "Approved", 
                oldValue: "Pending", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            // Reload table data and reset state
            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating record:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
            setShowRequestMessage(true);
            setIsSuccess(false);
        }
    
        setLoadingRequest(false);
        setSelectedDTR([]);
        setActiveRowIds([]);
    };

    useEffect(() => {
        fetchData();
        // setFetchUploads(() => fetchData());
    }, [fetchData, 
        isRevert,
        isProcess,
        isPost,
        isDelete,
        isUpload,
        isSelectLogs
    ]);

    useEffect(() => {
        if(showEditForm){
            setEmployeePersonalInformationEmployeeId(dataToEdit.employeePersonalInformationEmployeeId)
            setEmployeePersonalInformationId(dataToEdit.employeePersonalInformationId)
            setEmployeePersonalInformationFullName(dataToEdit.employeePersonalInformationFullName)
            setTimeIn(dataToEdit.timeIn)
            setDate(dataToEdit.date)
            setDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
            setTimeOut(dataToEdit.timeOut)
            setDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
            setReasonForTampering(dataToEdit.reasonForTampering)
            setOldTimeIn(dataToEdit.timeIn)
            setOldDeviceNameTimeIn(dataToEdit.deviceNameTimeIn)
            setOldTimeOut(dataToEdit.timeOut)
            setOldDeviceNameTimeOut(dataToEdit.deviceNameTimeOut)
            setOldReasonForTampering(dataToEdit.reasonForTampering)
        }
    }, [showEditForm, 
        dataToEdit, 
    ]);

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setDataToEdit(data);
        setShowEditForm(true);
    };
    const deleteHandleClick = (data) => {
        setShowDeleteForm(true);
        setDataToDelete(data);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };
    const closeDeleteHandleClick = () => {
        setShowDeleteForm(false);
    };
    const closeApproveHandleClick = () => {
        setShowApproveForm(false);
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    };
    //extract
    const fetchDataPayrollPeriodById = async (id) => {
        const apiUrl =  domain + `/api/PayrollPeriod/${id}`;

        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null;
        }
    }

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    function formatTime(time) {
        if(!time){
            return '';
        }

        const timePart = time.split('T')[1];
        if (timePart) {
            const [hour, minute] = timePart.split(':');
            const hours = parseInt(hour, 10);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;

            return `${formattedHours}:${minute} ${ampm}`;
        }
    }

    const exportToExcel = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'EmployeeId',
            'Name',
            'Date',
            'TimeIn',
            'DeviceIn',
            'TimeOut',
            'DeviceOut',
            'ShiftName',
            'ReasonForTampering'
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'deviceNameTimeIn', width: 30 },
            { key: 'timeOut', width: 30 },
            { key: 'deviceNameTimeOut', width: 30 },
            { key: 'employeePersonalInformationEmployeeInformationShiftScheduleShiftName', width: 30 },
            { key: 'reasonForTampering', width: 30 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });

        const payrollPeriodData = await fetchDataPayrollPeriodById(extractPayrollPeriodId);
        const payrollDateFrom = new Date(payrollPeriodData.dateFrom);
        const payrollDateTo = new Date(payrollPeriodData.dateTo);

        // Set the time to the end of the day for dateTo (23:59:59)
        payrollDateTo.setHours(23, 59, 59, 999);

        // Filter records where the date is within the range
        const filteredData = dateTimeRecordData.filter(record => {
            const recordDate = new Date(record.date);
            return recordDate >= payrollDateFrom && recordDate <= payrollDateTo;
        });

        const sortedData = [...filteredData].sort((a, b) => {
            // Sort by Name first
            if (a.employeePersonalInformationFullName < b.employeePersonalInformationFullName) return -1;
            if (a.employeePersonalInformationFullName > b.employeePersonalInformationFullName) return 1;
        
            // If Name is the same, sort by Date
            return new Date(a.date) - new Date(b.date);
        });
    
        sortedData.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                formatDate(item.date),
                formatTime(item.timeIn),
                item.deviceNameTimeIn,
                formatTime(item.timeOut),
                item.deviceNameTimeOut,
                item.employeePersonalInformationEmployeeInformationShiftScheduleShiftName,
                item.reasonForTampering,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'TimeEntries.xlsx');
    };
    
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [showRequestMessage]);

    useEffect(() => {
        if (approveMessage) {
            const timeoutId = setTimeout(() => {
                setApproveMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
    }, [approveMessage]);

    const [showAddForEmployeeGroup2Logs, setShowAddForEmployeeGroup2Logs] = useState(false);
    const [employeeGroup2Id, setEmployeeGroup2Id] = useState("");
    const [employeeGroup2DateFrom, setEmployeeGroup2DateFrom] = useState("");
    const [employeeGroup2DateTo, setEmployeeGroup2DateTo] = useState("");
    const openAddForEmployeeGroup2Form = () => {
        setShowAddForEmployeeGroup2Logs(true);
    }
    const closeAddForEmployeeGroup2Form = () => {
        setShowAddForEmployeeGroup2Logs(false);
    }

    /* const fetchDataEmployees = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";

        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []); */

    const handlAddEmployeeGroup2Logs = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);
        
        const _data = {
            employeeGroup2Id: employeeGroup2Id,
            dateFrom: employeeGroup2DateFrom,
            dateTo: employeeGroup2DateTo,
        }

        try {
            await axios.post(`${apiUrl}/fixed-logs`, _data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "For Employee Group 2", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeeGroup2Id("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
            closeAddForEmployeeGroup2Form();
        }
    };
/* 
    const handlAddEmployeeGroup2Logs = async (event) => {
        event.preventDefault();
        setLoadingRequest(true);

        const allEmployees = await fetchDataEmployees();
        const employeeGroup2 = allEmployees.filter(e => e.employeeInformation?.employeeGroup2Id?.toString() === employeeGroup2Id?.toString());

        const startDate = new Date(employeeGroup2DateFrom);
        const endDate = new Date(employeeGroup2DateTo);

        // Initialize array to hold bulk data
        const bulkData = [];

        // Generate logs for each date in the range
        for (let currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
            // Format the date as yyyy-mm-dd
            const formattedDate = currentDate.toISOString().split('T')[0];

            for (const employee of employeeGroup2) {
                // Create log for the current date
                const log = {
                    employeePersonalInformationId: employee.id,
                    employeePersonalInformationEmployeeId: employee.employeeId,
                    timeIn: `${formattedDate}T08:30:00`, // Set timeIn to 8:30 AM
                    timeOut: `${formattedDate}T17:30:00`, // Set timeOut to 5:30 PM
                    date: formattedDate,
                    createdById: user.id,
                    createdDate: new Date(),
                };

                bulkData.push(log);
            }
        }

        try {
            await axios.post(`${apiUrl}/bulk`, bulkData, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "insert", 
                field: "For Employee Group 2", 
                newValue: `${employeePersonalInformationFullName}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setEmployeeGroup2Id("");
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
            closeAddForEmployeeGroup2Form();
        }
    }; */

    const [showExtractForm, setShowExtractForm] = useState(false);
    const [extractPayrollPeriodId, setExtractPayrollPeriodId] = useState("");
    const openExtractForm = () => {
        setShowExtractForm(true);
    }
    const closeExtractForm = () => {
        setShowExtractForm(false);
    }

    return(
        <>
            <div style={{padding:"10px"}}>
                <div className='filters-payroll'>
                    <span>Filter</span>
                    <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "unset"}}>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodUploadedTimeEntries} setPayrollPeriodId={setPayrollPeriodUploadedTimeEntries} />
                            </div>
                        </div>
                        <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectWithAll1 user={user} classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} setActiveRowIds={setActiveRowIds} setSelectedDTR={setSelectedDTR}/>
                            </div>
                        </div>
                        { (filterClassificationId.toString() === "3") &&
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Section</div>
                                <div className="info-item-input">
                                    <SectionIdSelect sectionId={sectionFilter} setSectionId={setSectionFilter}/>
                                </div>
                            </div>
                        }
                        { (filterClassificationId.toString() === "2") &&
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Location</div>
                                <div className="info-item-input">
                                    <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                </div>
                            </div>
                        }
                        { (filterClassificationId.toString() === "3") &&
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Location</div>
                                <div className="info-item-input">
                                    <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                </div>
                            </div>
                        }
                        { (filterClassificationId.toString() === "4") &&
                            <div className="filter-item-payroll popUp-item info-item column">
                                <div className="info-item-label">Location</div>
                                <div className="info-item-input">
                                    <LocationIdSelect locationId={locationFilter} setLocationId={setLocationFilter}/>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="rightSide-btn" style={{marginRight:"5px"}}>{CreateButton("", "generate row", generateUploadedTimeEntries, "GENERATE", RestartAltIcon)}</div>
                </div>
            </div>
            <div className="timeBtns row">
                <div className="timeBtn add row">
                    {CreateButton("", "icon row", addHandleClick, "ADD", AddIcon)}
                </div>
                <div className="timeBtn add row">
                    {CreateButton("", "icon row", openAddForEmployeeGroup2Form, "FIXED LOGS", AddIcon)}
                </div>
                <div className="timeBtn extract row">
                    {CreateButton("", "icon row", openExtractForm, "EXTRACT", FileCopyIcon)}
                </div>
                <div className="timeBtn extract row">
                    {CreateButton("", "icon row", openUploadTamperedFormHandleClick, "UPLOAD TAMPERED ENTRIES", FileCopyIcon)}
                </div>
            </div>
            <div className="mainte-body-top row">
                    {Filter(setFilterDataIndex)}
            </div>
            <div className="mainte-body-top row timeEntries-search-div" style={{justifyContent: "space-between"}}>
                <>
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by name", 
                                                    SearchIcon)}
                </>
                <div className="timeBtns row" style={{padding: "0", display: "none"}}>
                    { !showTampered ?
                        <div className="timeBtn extract row">
                            {CreateButton("", "icon row", handleClickShowTampered, "SHOW TAMPERED ONLY", VisibilityOffIcon)}
                        </div>
                        :
                        <div className="timeBtn extract row">
                            {CreateButton("", "icon row", handleClickShowTampered, "SHOW ALL ENTRIES", RemoveRedEyeIcon)}
                        </div>
                    }
                    <div className="timeBtn approve row">
                        {CreateButton("", "icon row", ()=>setShowApproveForm(true), "APPROVE", DoneIcon)}
                    </div>
                    <div className="timeBtn approve row">
                        {CreateButton("", "icon row", ()=>setIsSelectAll(true), "SELECT ALL", ChecklistIcon)}
                    </div>
                </div>
            </div>
            <div className="timeTable container">
                <CreateTable
                    dataList={dateTimeRecordData}
                    dataHeader={uploadTimeEntriesHeader}
                    dataAccessor={uploadTimeEntriesaccessor}
                    editHandleClick={editHandleClick}
                    deleteHandleClick={deleteHandleClick}
                    setSelected={setSelectedDTR}
                    isSelectAll={isSelectAll}
                    setIsSelectAll={setIsSelectAll}
                    activeRowIds={activeRowIds}
                    setActiveRowIds={setActiveRowIds}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                />
                {dateTimeRecordData.length > 0 ? (
                    <div></div>
                )
                :
                (
                    <div>
                    {loading ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                            <img src={loadingSpinner} alt="Loading..." />
                        </div>
                    ) : (
                            <div> {/*<p>No records to display</p>*/}</div>
                        )
                    }
                    </div>
                )}
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    setShowEmployeeForm={setShowEmployeeForm}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    employeePersonalInformationId={employeePersonalInformationId}
                    setEmployeePersonalInformationId={setEmployeePersonalInformationId}
                    employeePersonalInformationFullName={employeePersonalInformationFullName}
                    setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
                    timeIn={timeIn} 
                    setTimeIn={setTimeIn}
                    deviceNameTimeIn={deviceNameTimeIn}
                    setDeviceNameTimeIn={setDeviceNameTimeIn}
                    timeOut={timeOut}
                    setTimeOut={setTimeOut}
                    deviceNameTimeOut={deviceNameTimeOut}
                    setDeviceNameTimeOut={setDeviceNameTimeOut}
                    reasonForTampering={reasonForTampering}
                    setReasonForTampering={setReasonForTampering}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <DeleteForm  isOpen={showDeleteForm} 
                    onClose={closeDeleteHandleClick}
                    handleDelete={handleDelete}
            >
            </DeleteForm>
            <ApproveForm  isOpen={showApproveForm} 
                    onClose={closeApproveHandleClick}
                    handleApprove={approveHandleClick}
            >
            </ApproveForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
                    userAccessData={userAccess}
            >
            </EmployeeSelectForm>
            <AddEmployeeGroup2LogsForm  isOpen={showAddForEmployeeGroup2Logs} 
                    onClose={closeAddForEmployeeGroup2Form}
                    employeeGroup2Id={employeeGroup2Id}
                    setEmployeeGroup2Id={setEmployeeGroup2Id}
                    employeeGroup2DateFrom={employeeGroup2DateFrom}
                    setEmployeeGroup2DateFrom={setEmployeeGroup2DateFrom}
                    employeeGroup2DateTo={employeeGroup2DateTo}
                    setEmployeeGroup2DateTo={setEmployeeGroup2DateTo}
                    handleSubmit={handlAddEmployeeGroup2Logs}
            >
            </AddEmployeeGroup2LogsForm>
            <ExtractForm  isOpen={showExtractForm} 
                    onClose={closeExtractForm}
                    payrollPeriodId={extractPayrollPeriodId} 
                    setPayrollPeriodId={setExtractPayrollPeriodId} 
                    handleSubmit={exportToExcel}
            >
            </ExtractForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            <GenerateMessage form={approveMessage}
                    message={requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </>
    )
}
function ProcessedTimeEntries({
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    userAccess,
    isGenerate,
    setFetchProcessedSummary,
    setFetchProcessedDetailed,
    isRevert,
    isProcess,
    isPost,
    fetchDataSummary,
    fetchDataDetailed,
    filterDataSummary,
    filterDataDetailed,
    dateTimeRecordDataSummary, 
    setDateTimeRecordDataSummary,
    dateTimeRecordDataDetailed, 
    setDateTimeRecordDataDetailed,
    loadingSummary,
    loadingDetailed
}){
    var processedTimeEntriesHeaderSummary = [
        "Id",
        "Employee Id",
        "Name",
        "Classification",
        "Payroll Period",
        "Pay Type",
        "Date Processed",
        "Total Days",
        "Total Absents",

        "Total Days Regular Holidays",
        "Total Regular Holidays Worked",
        "Total Days Special Non-Working Holidays",
        "Total Special Non-Working Holidays Worked",
        
        "Total Leaves",
        "Total Late",
        "Late Value",
        "Total Undertime",
        "Undertime Value",
        "Total Night Diff",
        "Night Diff Value",
        "Total Night Diff OT",
        "Total OT Regular",
        // "Total OT Regular Exceed",
        "Total OT Restday",
        // "Total OT Restday Exceed",
        "Total OT Holiday Special",
        // "Total Holiday Special Exceed",
        "Total OT Holiday Regular",
        // "Total Holiday Regular Exceed",
        "Total OT Restday Holiday Special",
        // "Total Restday Holiday Special Exceed",
        "Total OT Restday Holiday Regular",
        // "Total Restday Holiday Regular Exceed",
    ]
    var processedTimeEntriesaccessorSummary = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "payrollPeriodFull",
        "payTypeDescription",
        "dateProcessed",
        "totalDays",
        "totalAbsents",

        "totalDaysRegularHolidays",
        "totalRegularHolidayWorked",
        "totalDaysSpecialNonWorkingHolidays",
        "totalSpecialNonWorkingHolidaysWorked",

        "totalLeaves",
        "totalLate",
        "lateValue",
        "totalUndertime",
        "undertimeValue",
        "totalNighDiff",
        "nighDiffValue",
        "nighDiffOT",
        "totalOTRegular",
        // "totalOTRegularExceeded",
        "totalOTRestday",
        // "totalOTRestdayExceeded",
        "totalOTHolidaySpecial",
        // "totalOTHolidaySpecialExceeded",
        "totalOTHolidayRegular",
        // "totalOTHolidayRegularExceeded",
        "totalOTRestdayHolidaySpecial",
        // "totalOTRestdayHolidaySpecialExceeded",
        "totalOTRestdayHolidayRegular",
        // "totalOTRestdayHolidayRegularExceeded",
    ]
    var processedTimeEntriesHeaderDetailed = [
        "Id",
        "Employee Id",
        "Name",
        "Classification",
        "Date",
        "Time In",
        "Time Out",
        "Late",
        "Late Value",
        "Undertime",
        "Undertime Value",
        "Night Diff",
        "Night Diff Value",
        "Night Diff OT",
        "OT Regular",
        // "OT Regular Exceed",
        "OT Restday",
        // "OT Restday Exceed",
        "OT Holiday Special",
        // "Holiday Special Exceed",
        "OT Holiday Regular",
        // "Holiday Regular Exceed",
        "OT Restday Holiday Special",
        // "Restday Holiday Special Exceed",
        "OT Restday Holiday Regular",
        // "Restday Holiday Regular Exceed"
    ]
    var processedTimeEntriesaccessorDetailed = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "date",
        "timeIn",
        "timeOut",
        "late",
        "lateValue",
        "undertime",
        "undertimeValue",
        "nighDiff",
        "nighDiffValue",
        "nighDiffOT",
        "otRegular",
        // "otRegularExceeded",
        "otRestday",
        // "otRestdayExceeded",
        "otHolidaySpecial",
        // "otHolidaySpecialExceeded",
        "otHolidayRegular",
        // "otHolidayRegularExceeded",
        "otRestdayHolidaySpecial",
        // "otRestdayHolidaySpecialExceeded",
        "otRestdayHolidayRegular",
        // "otRestdayHolidayRegularExceeded"
    ]

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeButton, setActiveButton] = useState('summary');
    const [showFilterHeaderSummaryForm, setShowFilterHeaderSummaryForm] = useState(false);
    const [showFilterHeaderDetailedForm, setShowFilterHeaderDetailedForm] = useState(false);

    //Summary
    const storedHeaderText = localStorage.getItem('processedSummaryFilteredHeader');

    const [parsedHeaderText, setParsedHeaderText] = useState([]);

    useEffect(() => {
        try {
            const parsedData = storedHeaderText ? JSON.parse(storedHeaderText) : [];
            setParsedHeaderText(parsedData);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            setParsedHeaderText([]);
        }
    }, [storedHeaderText]);

    const [filteredHeaderForSummary, setFilteredHeaderForSummary] = useState(() => {
        if (parsedHeaderText.length > 0) {
            return Array(parsedHeaderText.length).fill(document.createElement('th'));
        } else {
            return [];
        }
    });

    useEffect(() => {
        if (parsedHeaderText.length > 0) {
            const updatedHeaders = parsedHeaderText.map((data) => {
                const thElement = document.createElement('th');
                thElement.textContent = data;
                return thElement;
            });
            setFilteredHeaderForSummary(updatedHeaders);
        } else {
            setFilteredHeaderForSummary([]);
        }
    }, [parsedHeaderText]);
    
    const [spawnedItems, setSpawnedItems] = useState([]);
    const [draggedHeader, setDraggedHeader] = useState(null);
    const [draggedHeaderName, setDraggedHeaderName] = useState("");
    //Detailed
    const storedHeaderTextDetailed = localStorage.getItem('processedDetailedFilteredHeader');

    const [parsedHeaderTextDetailed, setParsedHeaderTextDetailed] = useState([]);

    useEffect(() => {
        try {
            const parsedDataDetailed = storedHeaderTextDetailed ? JSON.parse(storedHeaderTextDetailed) : [];
            setParsedHeaderTextDetailed(parsedDataDetailed);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            setParsedHeaderTextDetailed([]);
        }
    }, [storedHeaderTextDetailed]);

    const [filteredHeaderForDetailed, setFilteredHeaderForDetailed] = useState(() => {
        if (parsedHeaderTextDetailed.length > 0) {
            return Array(parsedHeaderTextDetailed.length).fill(document.createElement('th'));
        } else {
            return [];
        }
    });

    useEffect(() => {
        if (parsedHeaderTextDetailed.length > 0) {
            const updatedHeaders = parsedHeaderTextDetailed.map((data) => {
                const thElement = document.createElement('th');
                thElement.textContent = data;
                return thElement;
            });
            setFilteredHeaderForDetailed(updatedHeaders);
        } else {
            setFilteredHeaderForDetailed([]);
        }
    }, [parsedHeaderTextDetailed]);

    const [spawnedItemsDetailed, setSpawnedItemsDetailed] = useState([]);
    const [draggedHeaderDetailed, setDraggedHeaderDetailed] = useState(null);
    const [draggedHeaderNameDetailed, setDraggedHeaderNameDetailed] = useState("");

    const handleTabClick = (id) =>{
        setCurrentPage(1);
        setActiveButton(id);
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        if(activeButton === "summary"){
            res = filterDataSummary.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

            setDateTimeRecordDataSummary(res);
        } else{
            res = filterDataDetailed.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

            setDateTimeRecordDataDetailed(res);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (isGenerate) {
                if (activeButton === "summary") {
                    await fetchDataSummary();
                } else if (activeButton === "detailed") {
                    await fetchDataDetailed();
                }
            }
        };

        fetchData();

        // setFetchProcessedSummary(() => fetchDataSummary());
        // setFetchProcessedDetailed(() => fetchDataDetailed());
        
    }, [isGenerate, 
        activeButton, 
        fetchDataSummary, 
        fetchDataDetailed,
        isRevert,
        isProcess,
        isPost,
    ]);

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    function formatTime(time) {
        if(!time){
            return '';
        }

        const timePart = time.split('T')[1];
        if (timePart) {
            const [hour, minute] = timePart.split(':');
            const hours = parseInt(hour, 10);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;

            return `${formattedHours}:${minute} ${ampm}`;
        }
    }

    const exportToExcelSummary = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Name',
            'Payroll Period',
            'Pay Type',
            'Date Processed',
            'Total Days',
            'Total Absents',
            'Total Days Regular Holidays',
            'Total Regular Holidays Worked',
            'Total Days Special Non-Working Holidays',
            'Total Special Non-Working Holidays Worked',
            'Total Leaves',
            'Total Late',
            'Late Value',
            'Total Undertime',
            'Undertime Value',
            'Total Night Diff',
            'Night Diff Value',
            'Total Night Diff OT',
            'Total OT Regular',
            'Total OT Restday',
            'Total Holiday Special',
            'Total Holiday Regular',
            'Total Restday Holiday Special',
            'Total Restday Holiday Regular',
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'payrollPeriodFull', width: 30 },
            { key: 'payTypeDescription', width: 30 },
            { key: 'dateProcessed', width: 30 },
            { key: 'totalDays', width: 20 },
            { key: 'totalAbsents', width: 20 },
            { key: 'totalDaysRegularHolidays', width: 20 },
            { key: 'totalRegularHolidayWorked', width: 20 },
            { key: 'totalDaysSpecialNonWorkingHolidays', width: 20 },
            { key: 'totalSpecialNonWorkingHolidaysWorked', width: 20 },
            { key: 'totalLeaves', width: 20 },
            { key: 'totalLate', width: 20 },
            { key: 'lateValue', width: 20 },
            { key: 'totalUndertime', width: 20 },
            { key: 'undertimeValue', width: 20 },
            { key: 'totalNighDiff', width: 20 },
            { key: 'nighDiffValue', width: 20 },
            { key: 'nighDiffOT', width: 20 },
            { key: 'totalOTRegular', width: 20 },
            { key: 'totalOTRestday', width: 20 },
            { key: 'totalOTHolidaySpecial', width: 20 },
            { key: 'totalOTHolidayRegular', width: 20 },
            { key: 'totalOTRestdayHolidaySpecial', width: 20 },
            { key: 'totalOTRestdayHolidayRegular', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        dateTimeRecordDataSummary.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                item.payrollPeriodFull,
                item.payTypeDescription,
                formatDate(item.dateProcessed),
                item.totalDays,
                item.totalAbsents,
                item.totalDaysRegularHolidays,
                item.totalRegularHolidayWorked,
                item.totalDaysSpecialNonWorkingHolidays,
                item.totalSpecialNonWorkingHolidaysWorked,
                item.totalLeaves,
                item.totalLate,
                item.lateValue,
                item.totalUndertime,
                item.undertimeValue,
                item.totalNighDiff,
                item.nighDiffValue,
                item.nighDiffOT,
                item.totalOTRegular,
                item.totalOTRestday,
                item.totalOTHolidaySpecial,
                item.totalOTHolidayRegular,
                item.totalOTRestdayHolidaySpecial,
                item.totalOTRestdayHolidayRegular,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'ProcessedSummary.xlsx');
    };
    const exportToExcelDetailed = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Name',
            'Date',
            'Time In',
            'Time Out',
            'Late',
            'Late Value',
            'Undertime',
            'Undertime Value',
            'Night Diff',
            'Night Diff Value',
            'Night Diff OT',
            'OT Regular',
            'OT Restday',
            'Holiday Special',
            'Holiday Regular',
            'Restday Holiday Special',
            'Restday Holiday Regular',
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'timeOut', width: 30 },
            { key: 'late', width: 20 },
            { key: 'lateValue', width: 20 },
            { key: 'undertime', width: 20 },
            { key: 'undertimeValue', width: 20 },
            { key: 'nighDiff', width: 20 },
            { key: 'nighDiffValue', width: 20 },
            { key: 'nighDiffOT', width: 20 },
            { key: 'otRegular', width: 20 },
            { key: 'otRestday', width: 20 },
            { key: 'otHolidaySpecial', width: 20 },
            { key: 'otHolidayRegular', width: 20 },
            { key: 'otRestdayHolidaySpecial', width: 20 },
            { key: 'otRestdayHolidayRegular', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        dateTimeRecordDataDetailed.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                formatDate(item.date),
                formatTime(item.timeIn),
                formatTime(item.timeOut),
                item.late,
                item.lateValue,
                item.undertime,
                item.undertimeValue,
                item.nighDiff,
                item.nighDiffValue,
                item.nighDiffOT,
                item.otRegular,
                item.otRestday,
                item.otHolidaySpecial,
                item.otHolidayRegular,
                item.otRestdayHolidaySpecial,
                item.otRestdayHolidayRegular,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'ProcessedDetailed.xlsx');
    };
    
    //Summary
    const handleDrop = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
        draggedHeader.style.display = "none";

        setFilteredHeaderForSummary(prevFilteredHeader => {
            const updatedFilteredHeader = [...prevFilteredHeader, draggedHeader];
            const updatedSpawnedItems = spawnedItems.filter(item => item !== draggedHeaderName);
            setSpawnedItems([...updatedSpawnedItems, item(draggedHeaderName, updatedFilteredHeader)]);
            return updatedFilteredHeader;
        });

        setDraggedHeader(null);
        setDraggedHeaderName("");
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#d19ac7";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
    };
    const handleDragStart = (e, header) => {
        e.dataTransfer.setData('text/plain', 'This is a draggable item');
        e.dataTransfer.effectAllowed = 'move';
        setDraggedHeader(e.currentTarget);
        setDraggedHeaderName(header);
    };
    const item = (name, _filteredHeaderForSummary) => {
        return (
            <div className='dragged-item row' style={{alignItems:"center", justifyContent: "center"}}>
                {name}
                <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItem(name, _filteredHeaderForSummary)}/>
            </div>
        )
        
    }
    const removeItem = (name, _filteredHeaderForSummary) => {
        setSpawnedItems(prevSpawnedItems => 
            prevSpawnedItems.filter(item => item.props.children[0] !== name)
        );
        setFilteredHeaderForSummary(prevFilteredHeader => 
            prevFilteredHeader.filter(item => item.textContent !== name)
        );
        _filteredHeaderForSummary.forEach(item => {
            // Remove sorting indicators (↑, ↓) and any additional spaces from item.textContent
            const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();
            
            if(name === cleanedTextContent){
                item.style.display = "";
            }
        });
    };
    //Detailed
    const handleDropDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
        draggedHeaderDetailed.style.display = "none";

        setFilteredHeaderForDetailed(prevFilteredHeader => {
            const updatedFilteredHeader = [...prevFilteredHeader, draggedHeaderDetailed];
            const updatedSpawnedItems = spawnedItemsDetailed.filter(item => item !== draggedHeaderDetailed);
            setSpawnedItemsDetailed([...updatedSpawnedItems, itemDetailed(draggedHeaderNameDetailed, updatedFilteredHeader)]);
            return updatedFilteredHeader;
        });

        setDraggedHeaderDetailed(null);
        setDraggedHeaderNameDetailed("");
    };
    const handleDragOverDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#d19ac7";
    };
    const handleDragOutDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
    };
    const handleDragStartDetailed = (e, header) => {
        e.dataTransfer.setData('text/plain', 'This is a draggable item');
        e.dataTransfer.effectAllowed = 'move';
        setDraggedHeaderDetailed(e.currentTarget);
        setDraggedHeaderNameDetailed(header);
    };
    const itemDetailed = (name, _filteredHeaderForDetailed) => {
        console.log(filteredHeaderForDetailed);
        return (
            <div className='dragged-item row' style={{alignItems:"center", justifyContent: "center"}}>
                {name}
                <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItemDetailed(name, _filteredHeaderForDetailed)}/>
            </div>
        )
        
    }
    const removeItemDetailed = (name, _filteredHeaderForDetailed) => {
        setSpawnedItemsDetailed(prevSpawnedItems => 
            prevSpawnedItems.filter(item => item.props.children[0] !== name)
        );
        setFilteredHeaderForDetailed(prevFilteredHeader => 
            prevFilteredHeader.filter(item => item.textContent !== name)
        );
        _filteredHeaderForDetailed.forEach(item => {
            const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();
            
            if(name === cleanedTextContent){
                item.style.display = "";
            }
        });
    };
    const openShowFilterHeaderSummaryForm = () =>{
        setShowFilterHeaderSummaryForm(true);
    }
    const closeShowFilterHeaderSummaryForm = () =>{
        setShowFilterHeaderSummaryForm(false);
    }
    const openShowFilterHeaderDetailedForm = () =>{
        setShowFilterHeaderDetailedForm(true);
    }
    const closeShowFilterHeaderDetailedForm = () =>{
        setShowFilterHeaderDetailedForm(false);
    }

    
    const [showLeaveDetails, setShowLeaveDetails] = useState(false);
    const [leaveDetails, setLeaveDetails] = useState(null);
    const openLeaveDetails = () => {
        setShowLeaveDetails(true);
    }
    const closeLeaveDetails = () => {
        setShowLeaveDetails(false);
        setLeaveDetails(null);
    }

    const fetchLeaveDetail = useCallback(async (_data) => {
        const _paramData = {
            payrollPeriodId: _data.payrollPeriodId,
            employeePersonalInformationId: _data.employeePersonalInformationId
        }

        try {
            const response = await axios.post(`${domain}/api/LeaveRequest/leave-detail`, _paramData, {
                headers: { 'Content-Type': 'application/json'}
            })
                
            return (response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);
    const viewLeaveHandleClick = async (_data) => {
        setLoading(true);
        openLeaveDetails()
        
        const _leaveDetails = await fetchLeaveDetail(_data)
        setLeaveDetails(_leaveDetails)

        setLoading(false);
    }

    return(
        <>
            <div className="timeBtns processed-post-btns row" style={{padding:"0", justifyContent:"space-between"}}>
                <div className='row'>
                    <div className="timeBtn summary row">
                        {CreateButton(activeButton === "summary" ? "active-button" : "", "icon row", ()=>handleTabClick("summary"), "SUMMARY", SummarizeIcon)}
                    </div>
                    <div className="timeBtn detailed row">
                        {CreateButton(activeButton === "detailed" ? "active-button" : "", "icon row", ()=>handleTabClick("detailed"), "DETAILED", DetailsIcon)}
                    </div>
                </div>
                <div style={{padding:"10px"}}>
                    <div className="timeBtn row">
                        <div className='filter-header' style={{marginRight:"5px"}}>
                            {CreateButton("", "icon row", ()=>activeButton === "summary" ? openShowFilterHeaderSummaryForm() : openShowFilterHeaderDetailedForm(), "FILTER TABLE HEADER", AutoAwesomeMotionIcon)}
                        </div>
                        <div className='extract'>
                            {CreateButton("", "icon row", ()=>activeButton === "summary" ? exportToExcelSummary() : exportToExcelDetailed(), "EXTRACT", FileCopyIcon)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mainte-body-top row">
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by name", 
                                                    SearchIcon)}
            </div>
            <div style={{display: activeButton === "summary" ? "block" : "none"}}>
                <div className='header-filter-holder'
                    onDrop={(e)=>handleDrop(e)}
                    onDragOver={(e)=>handleDragOver(e)}
                    onDragLeave={(e)=>handleDragOut(e)}
                >
                    {spawnedItems.length > 0 ?
                        <div className='row' style={{flexWrap:"wrap"}}>
                            {spawnedItems.map((item, index) => (
                                <React.Fragment key={index}>{item}</React.Fragment>
                            ))}
                        </div>
                    :
                        <span>Drag a header here to filter the table.</span>
                    }
                </div>
                <div id='summary-table' className="timeTable container">
                    <CreateTableWithHeaderDragSummary
                        dataList={dateTimeRecordDataSummary}
                        dataHeader={processedTimeEntriesHeaderSummary}
                        dataAccessor={processedTimeEntriesaccessorSummary}
                        handleDragStart={handleDragStart}
                        filteredHeaderForSummary={filteredHeaderForSummary}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        viewLeaveHandleClick={viewLeaveHandleClick}
                    />
                    {dateTimeRecordDataSummary.length > 0 ? (
                    <div></div>
                    )
                    :
                    (
                        <div>
                        {loadingSummary ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        ) : (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )
                        }
                        </div>
                    )}
                </div>
            </div>
            <div style={{display: activeButton === "summary" ? "none" : "block"}}>
                <div className='header-filter-holder'
                    onDrop={(e)=>handleDropDetailed(e)}
                    onDragOver={(e)=>handleDragOverDetailed(e)}
                    onDragLeave={(e)=>handleDragOutDetailed(e)}
                >
                    {spawnedItemsDetailed.length > 0 ?
                        <div className='row' style={{flexWrap:"wrap"}}>
                            {spawnedItemsDetailed.map((item, index) => (
                                <React.Fragment key={index}>{item}</React.Fragment>
                            ))}
                        </div>
                    :
                        <span>Drag a header here to filter the table.</span>
                    }
                </div>
                <div id='detailed-table' className="timeTable container">
                    <CreateTableWithHeaderDragDetailed
                        dataList={dateTimeRecordDataDetailed}
                        dataHeader={processedTimeEntriesHeaderDetailed}
                        dataAccessor={processedTimeEntriesaccessorDetailed}
                        handleDragStart={handleDragStartDetailed}
                        filteredHeaderForDetailed={filteredHeaderForDetailed}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        viewLeaveHandleClick={viewLeaveHandleClick}
                    />
                    {dateTimeRecordDataDetailed.length > 0 ? (
                    <div></div>
                    )
                    :
                    (
                        <div>
                        {loadingDetailed ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        ) : (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )
                        }
                        </div>
                    )}
                </div>
            </div>
            <FilterHeaderSummaryForm isOpen={showFilterHeaderSummaryForm}
                                onClose={closeShowFilterHeaderSummaryForm}
                                setFilteredHeaderForSummary={setFilteredHeaderForSummary}
            />
            <FilterHeaderDetailedForm isOpen={showFilterHeaderDetailedForm}
                                onClose={closeShowFilterHeaderDetailedForm}
                                setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
            />

            <ViewLeaveDetailForm
                isOpen={showLeaveDetails}
                onClose={closeLeaveDetails}
                leaveDetails={leaveDetails}
            />

            {loading &&
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            }
        </>
    )
}
function PostedTimeEntries({
    filterPayTypeId,
    filterPayrollPeriodId,
    filterClassificationId,
    filterLocationId,
    filterSectionId,
    userAccess,
    isGenerate,
    setFetchPostedSummary,
    setFetchPostedDetailed,
    isRevert,
    isProcess,
    isPost,
    fetchDataSummary,
    fetchDataDetailed,
    filterDataSummary,
    filterDataDetailed,
    loadingSummary,
    loadingDetailed,
    dateTimeRecordDataSummary,
    setDateTimeRecordDataSummary,
    dateTimeRecordDataDetailed,
    setDateTimeRecordDataDetailed
}){
    var processedTimeEntriesHeaderSummary = [
        "Id",
        "Employee Id",
        "Name",
        "Classification",
        "Payroll Period",
        "Pay Type",
        "Date Processed",
        "Total Days",
        "Total Absents",

        "Total Days Regular Holidays",
        "Total Regular Holidays Worked",
        "Total Days Special Non-Working Holidays",
        "Total Special Non-Working Holidays Worked",

        "Total Leaves",
        "Total Late",
        "Late Value",
        "Total Undertime",
        "Undertime Value",
        "Total Night Diff",
        "Night Diff Value",
        "Total Night Diff OT",
        "Total OT Regular",
        // "Total OT Regular Exceed",
        "Total OT Restday",
        // "Total OT Restday Exceed",
        "Total OT Holiday Special",
        // "Total Holiday Special Exceed",
        "Total OT Holiday Regular",
        // "Total Holiday Regular Exceed",
        "Total OT Restday Holiday Special",
        // "Total Restday Holiday Special Exceed",
        "Total OT Restday Holiday Regular",
        // "Total Restday Holiday Regular Exceed",
    ]
    var processedTimeEntriesaccessorSummary = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "payrollPeriodFull",
        "payTypeDescription",
        "dateProcessed",
        "totalDays",
        "totalAbsents",

        "totalDaysRegularHolidays",
        "totalRegularHolidayWorked",
        "totalDaysSpecialNonWorkingHolidays",
        "totalSpecialNonWorkingHolidaysWorked",

        "totalLeaves",
        "totalLate",
        "lateValue",
        "totalUndertime",
        "undertimeValue",
        "totalNighDiff",
        "nighDiffValue",
        "nighDiffOT",
        "totalOTRegular",
        // "totalOTRegularExceeded",
        "totalOTRestday",
        // "totalOTRestdayExceeded",
        "totalOTHolidaySpecial",
        // "totalOTHolidaySpecialExceeded",
        "totalOTHolidayRegular",
        // "totalOTHolidayRegularExceeded",
        "totalOTRestdayHolidaySpecial",
        // "totalOTRestdayHolidaySpecialExceeded",
        "totalOTRestdayHolidayRegular",
        // "totalOTRestdayHolidayRegularExceeded",
    ]
    var processedTimeEntriesHeaderDetailed = [
        "Id",
        "Employee Id",
        "Name",
        "Classification",
        "Date",
        "Time In",
        "Time Out",
        "Late",
        "Late Value",
        "Undertime",
        "Undertime Value",
        "Night Diff",
        "Night Diff Value",
        "Night Diff OT",
        "OT Regular",
        // "OT Regular Exceed",
        "OT Restday",
        // "OT Restday Exceed",
        "OT Holiday Special",
        // "Holiday Special Exceed",
        "OT Holiday Regular",
        // "Holiday Regular Exceed",
        "OT Restday Holiday Special",
        // "Restday Holiday Special Exceed",
        "OT Restday Holiday Regular",
        // "Restday Holiday Regular Exceed"
    ]
    var processedTimeEntriesaccessorDetailed = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "classificationDescription",
        "date",
        "timeIn",
        "timeOut",
        "late",
        "lateValue",
        "undertime",
        "undertimeValue",
        "nighDiff",
        "nighDiffValue",
        "nighDiffOT",
        "otRegular",
        // "otRegularExceeded",
        "otRestday",
        // "otRestdayExceeded",
        "otHolidaySpecial",
        // "otHolidaySpecialExceeded",
        "otHolidayRegular",
        // "otHolidayRegularExceeded",
        "otRestdayHolidaySpecial",
        // "otRestdayHolidaySpecialExceeded",
        "otRestdayHolidayRegular",
        // "otRestdayHolidayRegularExceeded"
    ]

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeButton, setActiveButton] = useState('summary');
    const [showFilterHeaderSummaryForm, setShowFilterHeaderSummaryForm] = useState(false);
    const [showFilterHeaderDetailedForm, setShowFilterHeaderDetailedForm] = useState(false);

    //Summary
    const storedHeaderText = localStorage.getItem('postedSummaryFilteredHeader');

    const [parsedHeaderText, setParsedHeaderText] = useState([]);

    useEffect(() => {
        try {
            const parsedData = storedHeaderText ? JSON.parse(storedHeaderText) : [];
            setParsedHeaderText(parsedData);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            setParsedHeaderText([]);
        }
    }, [storedHeaderText]);

    const [filteredHeaderForSummary, setFilteredHeaderForSummary] = useState(() => {
        if (parsedHeaderText.length > 0) {
            return Array(parsedHeaderText.length).fill(document.createElement('th'));
        } else {
            return [];
        }
    });

    useEffect(() => {
        if (parsedHeaderText.length > 0) {
            const updatedHeaders = parsedHeaderText.map((data) => {
                const thElement = document.createElement('th');
                thElement.textContent = data;
                return thElement;
            });
            setFilteredHeaderForSummary(updatedHeaders);
        } else {
            setFilteredHeaderForSummary([]);
        }
    }, [parsedHeaderText]);

    const [spawnedItems, setSpawnedItems] = useState([]);
    const [draggedHeader, setDraggedHeader] = useState(null);
    const [draggedHeaderName, setDraggedHeaderName] = useState("");
    //Detailed
    const storedHeaderTextDetailed = localStorage.getItem('postedDetailedFilteredHeader');

    const [parsedHeaderTextDetailed, setParsedHeaderTextDetailed] = useState([]);

    useEffect(() => {
        try {
            const parsedDataDetailed = storedHeaderTextDetailed ? JSON.parse(storedHeaderTextDetailed) : [];
            setParsedHeaderTextDetailed(parsedDataDetailed);
        } catch (error) {
            console.error('Error parsing JSON:', error);
            setParsedHeaderTextDetailed([]);
        }
    }, [storedHeaderTextDetailed]);

    const [filteredHeaderForDetailed, setFilteredHeaderForDetailed] = useState(() => {
        if (parsedHeaderTextDetailed.length > 0) {
            return Array(parsedHeaderTextDetailed.length).fill(document.createElement('th'));
        } else {
            return [];
        }
    });

    useEffect(() => {
        if (parsedHeaderTextDetailed.length > 0) {
            const updatedHeaders = parsedHeaderTextDetailed.map((data) => {
                const thElement = document.createElement('th');
                thElement.textContent = data;
                return thElement;
            });
            setFilteredHeaderForDetailed(updatedHeaders);
        } else {
            setFilteredHeaderForDetailed([]);
        }
    }, [parsedHeaderTextDetailed]);

    const [spawnedItemsDetailed, setSpawnedItemsDetailed] = useState([]);
    const [draggedHeaderDetailed, setDraggedHeaderDetailed] = useState(null);
    const [draggedHeaderNameDetailed, setDraggedHeaderNameDetailed] = useState("");

    const handleTabClick = (id) =>{
        setCurrentPage(1);
        setActiveButton(id);
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        if(activeButton === "summary"){
            res = filterDataSummary.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

            setDateTimeRecordDataSummary(res);
        } else{
            res = filterDataDetailed.filter((f) =>
                f.employeePersonalInformationFullName.toLowerCase().includes(lowercaseValue)
                );

            setDateTimeRecordDataDetailed(res);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (isGenerate) {
                if (activeButton === "summary") {
                    await fetchDataSummary();
                } else if (activeButton === "detailed") {
                    await fetchDataDetailed();
                }
            }
        };

        fetchData();

        // setFetchPostedSummary(()=>fetchDataSummary());
        // setFetchPostedDetailed(()=>fetchDataDetailed());
        
    }, [isGenerate, 
        activeButton, 
        fetchDataSummary, 
        fetchDataDetailed, 
        isRevert,
        isProcess,
        isPost,
    ]);

    function formatDate(dateString) {
        if(!dateString){
            return '';
        }
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    
    function formatTime(time) {
        if(!time){
            return '';
        }

        const timePart = time.split('T')[1];
        if (timePart) {
            const [hour, minute] = timePart.split(':');
            const hours = parseInt(hour, 10);
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;

            return `${formattedHours}:${minute} ${ampm}`;
        }
    }
    
    const exportToExcelSummary = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Name',
            'Payroll Period',
            'Pay Type',
            'Date Processed',
            'Total Days',
            'Total Absents',
            'Total Days Regular Holidays',
            'Total Regular Holidays Worked',
            'Total Days Special Non-Working Holidays',
            'Total Special Non-Working Holidays Worked',
            'Total Leaves',
            'Total Late',
            'Late Value',
            'Total Undertime',
            'Undertime Value',
            'Total Night Diff',
            'Night Diff Value',
            'Total Night Diff OT',
            'Total OT Regular',
            'Total OT Restday',
            'Total OT Holiday Special',
            'Total OT Holiday Regular',
            'Total OT Restday Holiday Special',
            'Total OT Restday Holiday Regular',
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'payrollPeriodFull', width: 30 },
            { key: 'payTypeDescription', width: 30 },
            { key: 'dateProcessed', width: 30 },
            { key: 'totalDays', width: 20 },
            { key: 'totalAbsents', width: 20 },
            { key: 'totalDaysRegularHolidays', width: 20 },
            { key: 'totalRegularHolidayWorked', width: 20 },
            { key: 'totalDaysSpecialNonWorkingHolidays', width: 20 },
            { key: 'totalSpecialNonWorkingHolidaysWorked', width: 20 },
            { key: 'totalLeaves', width: 20 },
            { key: 'totalLate', width: 20 },
            { key: 'lateValue', width: 20 },
            { key: 'totalUndertime', width: 20 },
            { key: 'undertimeValue', width: 20 },
            { key: 'totalNighDiff', width: 20 },
            { key: 'nighDiffValue', width: 20 },
            { key: 'nighDiffOT', width: 20 },
            { key: 'totalOTRegular', width: 20 },
            { key: 'totalOTRestday', width: 20 },
            { key: 'totalOTHolidaySpecial', width: 20 },
            { key: 'totalOTHolidayRegular', width: 20 },
            { key: 'totalOTRestdayHolidaySpecial', width: 20 },
            { key: 'totalOTRestdayHolidayRegular', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        dateTimeRecordDataSummary.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                item.payrollPeriodFull,
                item.payTypeDescription,
                formatDate(item.dateProcessed),
                item.totalDays,
                item.totalAbsents,
                item.totalDaysRegularHolidays,
                item.totalRegularHolidayWorked,
                item.totalDaysSpecialNonWorkingHolidays,
                item.totalSpecialNonWorkingHolidaysWorked,
                item.totalLeaves,
                item.totalLate,
                item.lateValue,
                item.totalUndertime,
                item.undertimeValue,
                item.totalNighDiff,
                item.nighDiffValue,
                item.nighDiffOT,
                item.totalOTRegular,
                item.totalOTRestday,
                item.totalOTHolidaySpecial,
                item.totalOTHolidayRegular,
                item.totalOTRestdayHolidaySpecial,
                item.totalOTRestdayHolidayRegular,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'ProcessedSummary.xlsx');
    };
    const exportToExcelDetailed = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet();

        const header = [
            'Id',
            'Employee Id',
            'Name',
            'Date',
            'Time In',
            'Time Out',
            'Late',
            'Late Value',
            'Undertime',
            'Undertime Value',
            'Night Diff',
            'Night Diff Value',
            'Night Diff OT',
            'OT Regular',
            'OT Restday',
            'OT Holiday Special',
            'OT Holiday Regular',
            'OT Restday Holiday Special',
            'OT Restday Holiday Regular',
        ];
        const headerRow = worksheet.addRow(header);
        worksheet.columns = [
            { key: 'id', width: 30 },
            { key: 'employeePersonalInformationEmployeeId', width: 30 },
            { key: 'employeePersonalInformationFullName', width: 30 },
            { key: 'date', width: 30 },
            { key: 'timeIn', width: 30 },
            { key: 'timeOut', width: 30 },
            { key: 'late', width: 20 },
            { key: 'lateValue', width: 20 },
            { key: 'undertime', width: 20 },
            { key: 'undertimeValue', width: 20 },
            { key: 'nighDiff', width: 20 },
            { key: 'nighDiffValue', width: 20 },
            { key: 'nighDiffOT', width: 20 },
            { key: 'otRegular', width: 20 },
            { key: 'otRestday', width: 20 },
            { key: 'otHolidaySpecial', width: 20 },
            { key: 'otHolidayRegular', width: 20 },
            { key: 'otRestdayHolidaySpecial', width: 20 },
            { key: 'otRestdayHolidayRegular', width: 20 },
        ];
        headerRow.eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '92d050' },
            };
        });
    
        dateTimeRecordDataDetailed.forEach((item) => {
            worksheet.addRow([
                item.id,
                item.employeePersonalInformationEmployeeId,
                item.employeePersonalInformationFullName,
                formatDate(item.date),
                formatTime(item.timeIn),
                formatTime(item.timeOut),
                item.late,
                item.lateValue,
                item.undertime,
                item.undertimeValue,
                item.nighDiff,
                item.nighDiffValue,
                item.nighDiffOT,
                item.otRegular,
                item.otRestday,
                item.otHolidaySpecial,
                item.otHolidayRegular,
                item.otRestdayHolidaySpecial,
                item.otRestdayHolidayRegular,
            ]);
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, 'ProcessedDetailed.xlsx');
    };

    //Summary
    const handleDrop = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
        draggedHeader.style.display = "none";
        console.log(filteredHeaderForSummary)

        setFilteredHeaderForSummary(prevFilteredHeader => {
            const updatedFilteredHeader = [...prevFilteredHeader, draggedHeader];
            const updatedSpawnedItems = spawnedItems.filter(item => item !== draggedHeaderName);
            setSpawnedItems([...updatedSpawnedItems, item(draggedHeaderName, updatedFilteredHeader)]);
            return updatedFilteredHeader;
        });

        setDraggedHeader(null);
        setDraggedHeaderName("");
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#d19ac7";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
    };
    const handleDragStart = (e, header) => {
        e.dataTransfer.setData('text/plain', 'This is a draggable item');
        e.dataTransfer.effectAllowed = 'move';
        setDraggedHeader(e.currentTarget);
        setDraggedHeaderName(header);
    };
    const item = (name, _filteredHeaderForSummary) => {
        return (
            <div className='dragged-item row' style={{alignItems:"center", justifyContent: "center"}}>
                {name}
                <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItem(name, _filteredHeaderForSummary)}/>
            </div>
        )
        
    }
    const removeItem = (name, _filteredHeaderForSummary) => {
        setSpawnedItems(prevSpawnedItems => 
            prevSpawnedItems.filter(item => item.props.children[0] !== name)
        );
        setFilteredHeaderForSummary(prevFilteredHeader => 
            prevFilteredHeader.filter(item => item.textContent !== name)
        );
        _filteredHeaderForSummary.forEach(item => {
            const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();
            
            if(name === cleanedTextContent){
                item.style.display = "";
            }
        });
    };
    //Detailed
    const handleDropDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
        draggedHeaderDetailed.style.display = "none";

        setFilteredHeaderForDetailed(prevFilteredHeader => {
            const updatedFilteredHeader = [...prevFilteredHeader, draggedHeaderDetailed];
            const updatedSpawnedItems = spawnedItemsDetailed.filter(item => item !== draggedHeaderDetailed);
            setSpawnedItemsDetailed([...updatedSpawnedItems, itemDetailed(draggedHeaderNameDetailed, updatedFilteredHeader)]);
            return updatedFilteredHeader;
        });

        setDraggedHeaderDetailed(null);
        setDraggedHeaderNameDetailed("");
    };
    const handleDragOverDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#d19ac7";
    };
    const handleDragOutDetailed = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#ffd4f7";
    };
    const handleDragStartDetailed = (e, header) => {
        e.dataTransfer.setData('text/plain', 'This is a draggable item');
        e.dataTransfer.effectAllowed = 'move';
        setDraggedHeaderDetailed(e.currentTarget);
        setDraggedHeaderNameDetailed(header);
    };
    const itemDetailed = (name, _filteredHeaderForDetailed) => {
        console.log(filteredHeaderForDetailed);
        return (
            <div className='dragged-item row' style={{alignItems:"center", justifyContent: "center"}}>
                {name}
                <CloseIcon className='dragged-item-close' fontSize='12px' onClick={() => removeItemDetailed(name, _filteredHeaderForDetailed)}/>
            </div>
        )
        
    }
    const removeItemDetailed = (name, _filteredHeaderForDetailed) => {
        setSpawnedItemsDetailed(prevSpawnedItems => 
            prevSpawnedItems.filter(item => item.props.children[0] !== name)
        );
        setFilteredHeaderForDetailed(prevFilteredHeader => 
            prevFilteredHeader.filter(item => item.textContent !== name)
        );
        _filteredHeaderForDetailed.forEach(item => {
            const cleanedTextContent = item.textContent.replace(/[↑↓]/g, '').trim();
            
            if(name === cleanedTextContent){
                item.style.display = "";
            }
        });
    };
    const openShowFilterHeaderSummaryForm = () =>{
        setShowFilterHeaderSummaryForm(true);
    }
    const closeShowFilterHeaderSummaryForm = () =>{
        setShowFilterHeaderSummaryForm(false);
    }
    const openShowFilterHeaderDetailedForm = () =>{
        setShowFilterHeaderDetailedForm(true);
    }
    const closeShowFilterHeaderDetailedForm = () =>{
        setShowFilterHeaderDetailedForm(false);
    }
    
    const [showLeaveDetails, setShowLeaveDetails] = useState(false);
    const [leaveDetails, setLeaveDetails] = useState(null);
    const openLeaveDetails = () => {
        setShowLeaveDetails(true);
    }
    const closeLeaveDetails = () => {
        setShowLeaveDetails(false);
        setLeaveDetails(null);
    }

    const fetchLeaveDetail = useCallback(async (_data) => {
        const _paramData = {
            payrollPeriodId: _data.payrollPeriodId,
            employeePersonalInformationId: _data.employeePersonalInformationId
        }

        try {
            const response = await axios.post(`${domain}/api/LeaveRequest/leave-detail`, _paramData, {
                headers: { 'Content-Type': 'application/json'}
            })
                
            return (response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);
    const viewLeaveHandleClick = async (_data) => {
        setLoading(true);
        openLeaveDetails()
        
        const _leaveDetails = await fetchLeaveDetail(_data)
        setLeaveDetails(_leaveDetails)

        setLoading(false);
    }

    return(
        <>
            <div className="timeBtns processed-post-btns row" style={{padding:"0", justifyContent:"space-between"}}>
                <div className='row'>
                    <div className="timeBtn summary row">
                        {CreateButton(activeButton === "summary" ? "active-button" : "", "icon row", ()=>handleTabClick("summary"), "SUMMARY", SummarizeIcon)}
                    </div>
                    <div className="timeBtn detailed row">
                        {CreateButton(activeButton === "detailed" ? "active-button" : "", "icon row", ()=>handleTabClick("detailed"), "DETAILED", DetailsIcon)}
                    </div>
                </div>
                <div style={{padding:"10px"}}>
                    <div className="timeBtn row">
                        <div className='filter-header' style={{marginRight:"5px"}}>
                            {CreateButton("", "icon row", ()=>activeButton === "summary" ? openShowFilterHeaderSummaryForm() : openShowFilterHeaderDetailedForm(), "FILTER TABLE HEADER", AutoAwesomeMotionIcon)}
                        </div>
                        <div className='extract'>
                            {CreateButton("", "icon row", ()=>activeButton === "summary" ? exportToExcelSummary() : exportToExcelDetailed(), "EXTRACT", FileCopyIcon)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mainte-body-top row">
                    {CreateSearchBarWithPlaceHolder("", 
                                                    "mainte-search row", 
                                                    "mainte-search-icon", 
                                                    "mainte-search-input", 
                                                    (e) => handleFilter(e.target.value), 
                                                    "Search by name", 
                                                    SearchIcon)}
            </div>
            <div style={{display: activeButton === "summary" ? "block" : "none"}}>
                <div className='header-filter-holder'
                    onDrop={(e)=>handleDrop(e)}
                    onDragOver={(e)=>handleDragOver(e)}
                    onDragLeave={(e)=>handleDragOut(e)}
                >
                    {spawnedItems.length > 0 ?
                        <div className='row' style={{flexWrap:"wrap"}}>
                            {spawnedItems.map((item, index) => (
                                <React.Fragment key={index}>{item}</React.Fragment>
                            ))}
                        </div>
                    :
                        <span>Drag a header here to filter the table.</span>
                    }
                </div>
                <div id='summary-table' className="timeTable container">
                    <CreateTableWithHeaderDragSummary
                        dataList={dateTimeRecordDataSummary}
                        dataHeader={processedTimeEntriesHeaderSummary}
                        dataAccessor={processedTimeEntriesaccessorSummary}
                        handleDragStart={handleDragStart}
                        filteredHeaderForSummary={filteredHeaderForSummary}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        viewLeaveHandleClick={viewLeaveHandleClick}
                    />
                    {dateTimeRecordDataSummary.length > 0 ? (
                    <div></div>
                    )
                    :
                    (
                        <div>
                        {loadingSummary ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        ) : (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )
                        }
                        </div>
                    )}
                </div>
            </div>
            <div style={{display: activeButton === "summary" ? "none" : "block"}}>
                <div className='header-filter-holder'
                    onDrop={(e)=>handleDropDetailed(e)}
                    onDragOver={(e)=>handleDragOverDetailed(e)}
                    onDragLeave={(e)=>handleDragOutDetailed(e)}
                >
                    {spawnedItemsDetailed.length > 0 ?
                        <div className='row' style={{flexWrap:"wrap"}}>
                            {spawnedItemsDetailed.map((item, index) => (
                                <React.Fragment key={index}>{item}</React.Fragment>
                            ))}
                        </div>
                    :
                        <span>Drag a header here to filter the table.</span>
                    }
                </div>
                <div id='detailed-table' className="timeTable container">
                    <CreateTableWithHeaderDragDetailed
                        dataList={dateTimeRecordDataDetailed}
                        dataHeader={processedTimeEntriesHeaderDetailed}
                        dataAccessor={processedTimeEntriesaccessorDetailed}
                        handleDragStart={handleDragStartDetailed}
                        filteredHeaderForDetailed={filteredHeaderForDetailed}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        viewLeaveHandleClick={viewLeaveHandleClick}
                    />
                    {dateTimeRecordDataDetailed.length > 0 ? (
                    <div></div>
                    )
                    :
                    (
                        <div>
                        {loadingDetailed ? (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                <img src={loadingSpinner} alt="Loading..." />
                            </div>
                        ) : (
                                <div> {/*<p>No records to display</p>*/}</div>
                            )
                        }
                        </div>
                    )}
                </div>
            </div>
            <FilterHeaderPostedSummaryForm isOpen={showFilterHeaderSummaryForm}
                                onClose={closeShowFilterHeaderSummaryForm}
                                setFilteredHeaderForSummary={setFilteredHeaderForSummary}
            />
            <FilterHeaderPostedDetailedForm isOpen={showFilterHeaderDetailedForm}
                                onClose={closeShowFilterHeaderDetailedForm}
                                setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
            />

            <ViewLeaveDetailForm
                isOpen={showLeaveDetails}
                onClose={closeLeaveDetails}
                leaveDetails={leaveDetails}
            />

            {loading &&
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "10000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            }
        </>
    )
}
function SettingInit({
    user,
    generateDownloadTemplate,
    openSelectDataLogs,
    openRevertTimeForm,
    openProcessTimeForm,
    openPostTimeForm,
    openDeleteAll,
    openUploadFormHandleClick
}){
    const handleUploadClick = () =>{
        openUploadFormHandleClick();
    }
    return(
        <div id='payroll-setting' className="payroll-setting column">
            <div className="payroll-setting-item row" onClick={()=>generateDownloadTemplate(false)}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><DownloadIcon/></div>
                Download Template
            </div>
            <div className="payroll-setting-item row" onClick={()=>openSelectDataLogs()}>
                <div style={{margin: "10px 5px 0 5px", color:"#29aec5"}}><MenuBookIcon/></div>
                Select Data Logs
            </div>
            <div className="payroll-setting-item row"onClick={()=>handleUploadClick()}>
                <div style={{margin: "10px 5px 0 5px", color:"#47d147"}}><FileUploadIcon/></div>
                Upload Time Entries
            </div>
            { user.username === "admin" && <div className="payroll-setting-item row"onClick={()=>openDeleteAll()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><DeleteSweepIcon/></div>
                    Delete All Uploaded Time Entries
                </div>
            }
            <div className="payroll-setting-item row" onClick={()=>openRevertTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ff4d4d"}}><SettingsBackupRestoreIcon/></div>
                Revert Time Entries
            </div>
            <div className="payroll-setting-item row" onClick={()=>openProcessTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#ffaa00"}}><AccountTreeIcon/></div>
                Process Time Entries
            </div>
            <div className="payroll-setting-item row" onClick={()=>openPostTimeForm()}>
                <div style={{margin: "10px 5px 0 5px", color:"#1a75ff"}}><PostAddIcon/></div>
                Post Time Entries
            </div>
        </div>
    )
}
function AddForm({
    isOpen, 
    onClose,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    setShowEmployeeForm,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
        || !timeIn
        // || !deviceNameTimeIn
        || !timeOut
        // || !deviceNameTimeOut
    ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                    <button className="select row"
                                            onClick={()=>setShowEmployeeForm(true)}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    timeIn,
    setTimeIn,
    deviceNameTimeIn,
    setDeviceNameTimeIn,
    timeOut,
    setTimeOut,
    deviceNameTimeOut,
    setDeviceNameTimeOut,
    reasonForTampering,
    setReasonForTampering,
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeePersonalInformationId
            || !timeIn
            // || !deviceNameTimeIn
            || !timeOut
            // || !deviceNameTimeOut
            || !reasonForTampering
        ){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setTimeIn("");
        setDeviceNameTimeIn("");
        setTimeOut("");
        setDeviceNameTimeOut("");
        setReasonForTampering("");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Time Entry</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        style={{cursor:"not-allowed"}}
                                        value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                    />
                                </div>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeIn} setDate={setTimeIn}/>
                            </div>
                            <span style={{
                                        visibility: !timeIn && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time In Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeIn} setDevice={setDeviceNameTimeIn} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out</div>
                            <div className="info-item-input">
                                <DateTimeInput date={timeOut} setDate={setTimeOut}/>
                            </div>
                            <span style={{
                                        visibility: !timeOut && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Time Out Device</div>
                            <div className="info-item-input">
                                <TimeDevice device={deviceNameTimeOut} setDevice={setDeviceNameTimeOut} />
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Reason For Tampering</div>
                            <div className="info-item-input">
                                <textarea id="tamper" className="filterSelect"
                                        style={{width:"100%",minHeight:"50px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={reasonForTampering}
                                        onChange={(e)=>setReasonForTampering(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !reasonForTampering && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DeleteForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete this?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function SelectLogsForm({isOpen, 
    onClose,
    dateFromLogs,
    setDateFromLogs,
    dateToLogs,
    setDateToLogs,
    employeePersonalInformationId,
    setEmployeePersonalInformationId,
    employeePersonalInformationFullName,
    setEmployeePersonalInformationFullName,
    deviceLogs,
    setDeviceLogs,
    setShowEmployeeForm,
    classificationFilterForAdminHRHead, 
    setClassificationFilterForAdminHRHead,
    classificationFilterForHRAsst2, 
    setClassificationFilterForHRAsst2,
    classificationFilterForHRAsst3, 
    setClassificationFilterForHRAsst3,
    handleSelectDataLogs,
    handleSelectDataLogs_Mobile,
    handleSelectDataLogs_main,
    userAccessData,
    user
}){
    const [errorState, setErrorState] = useState(false);
    const [logType, setLogType] = useState("Sentry Biometrics");

    const submit = (e) =>{
        if (!dateFromLogs 
            || !dateToLogs
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        // if(logType === "Sentry Biometrics"){
        //     handleSelectDataLogs(e);
        // } else {
        //     handleSelectDataLogs_Mobile(e);
        // }
        handleSelectDataLogs_main(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDateFromLogs("");
        setDateToLogs("");
        setEmployeePersonalInformationId("");
        setEmployeePersonalInformationFullName("");
        setDeviceLogs("");
        setLogType("DTR Biometrics");
        setErrorState(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Data Logs</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column" style={{display: "none"}}>
                            <div className="info-item-label">Log Type</div>
                            <div className="info-item-input">
                                <LogTypeSelect logType={logType} setLogType={setLogType}/>
                            </div>
                            <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateInput date={dateFromLogs} setDate={setDateFromLogs}/>
                            </div>
                            <span style={{
                                        visibility: !dateFromLogs && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateInput date={dateToLogs} setDate={setDateToLogs}/>
                            </div>
                            <span style={{
                                        visibility: !dateToLogs && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        {userAccessData.length <= 0 && 
                            <div className="popUp-item info-item column">
                                <div className="info-item-label">Classification Type</div>
                                <div className="info-item-input">
                                    <ClassificationIdSelectDummy/>
                                    <span style={{
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        }
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelect classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead} user={user}/>
                                <span style={{
                                        visibility: "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        { logType === "Sentry Biometrics" &&
                            <div className="popUp-item info-item column" style={{display: "none"}}>
                                <div className="info-item-label">Device Name</div>
                                <div className="info-item-input">
                                    <TimeDevice device={deviceLogs} setDevice={setDeviceLogs} />
                                </div>
                                <span style={{
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                            </div>
                        }
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                SELECT
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function RevertTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchProcessedSummary,
    fetchProcessedDetailed,
    fetchPostedSummary,
    fetchPostedDetailed,
    setIsRevert,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleRevert(e);
        setErrorState(false);
        setIsRevert(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/EmployeeTimeRecord`);
    
    const handleRevert = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/revert`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };

        try {
            setLoadingPercentage(10); // Initial 10%
            setLoadingRequest(true);
    
            // Simulate gradual loading progress while waiting for axios.post
            simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step
    
            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "revert", 
                field: "Revert Time Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await simulateLoading(50, 100);
            await fetchUploads();

            await simulateLoading(60, 100);
            await fetchProcessedSummary();

            await simulateLoading(70, 100);
            await fetchProcessedDetailed();

            await simulateLoading(80, 100);
            await fetchPostedSummary();

            await simulateLoading(90, 100);
            await fetchPostedDetailed();

            setShowRequestMessage(true);
            setIsSuccess(true);

            simulateLoading(95, 100);

            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false

            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state

            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 0); // Delay to show full completion before resetting
        }
    }

    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Revert Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter user={user} classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                REVERT
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function ProcessTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchProcessedSummary,
    fetchProcessedDetailed,
    fetchPostedSummary,
    fetchPostedDetailed,
    setIsProcess,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    // const [loadingPercentage, setLoadingPercentage] = useState(0);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handleProcess(e);
        setErrorState(false);
        setIsProcess(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };

    const apiUrlRef = useRef( domain + `/api/EmployeeTimeRecord`);
    
    const handleProcess = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };
    
        try {
            setLoadingRequest(true);
            setLoadingPercentage(10); // Start at 10%
    
            // Simulate gradual loading progress while waiting for axios.post
            await simulateLoading(30, 200); // Await the loading simulation
    
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
    
            setLoadingPercentage(30); // Set immediate jump to 30% after axios call finishes
    
            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "process", 
                field: "Process Time Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });
    
            await simulateLoading(50, 100); // Wait for loading to simulate reaching 50%
            await fetchUploads();
    
            await simulateLoading(60, 100); // Wait for loading to simulate reaching 60%
            await fetchProcessedSummary();
    
            await simulateLoading(70, 100); // Wait for loading to simulate reaching 70%
            await fetchProcessedDetailed();
    
            await simulateLoading(80, 100); // Wait for loading to simulate reaching 80%
            await fetchPostedSummary();
    
            await simulateLoading(90, 100); // Wait for loading to simulate reaching 90%
            await fetchPostedDetailed();
    
            setShowRequestMessage(true);
            setIsSuccess(true);
    
            await simulateLoading(95, 100); // Ensure the loading reaches 95%
    
            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false
    
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
    
            // Safeguard in case the error structure is different
            const errorMessage = error?.response?.data?.message || 'An error occurred during processing.';
            setRequestMessage(errorMessage);
    
            // Optionally simulate slow reset to 0 to show failure state
            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 500); // Delay slightly to show full completion before resetting
        }
    };

    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Process Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter user={user} classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                PROCESS
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                    <p>{`Loading: ${loadingPercentage}%`}</p>
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function PostTimeEntriesForm({isOpen, 
    onClose,
    fetchUploads,
    fetchProcessedSummary,
    fetchProcessedDetailed,
    fetchPostedSummary,
    fetchPostedDetailed,
    setIsPost,
    user,

    loadingRequest,
    setLoadingRequest,
    loadingPercentage, 
    setLoadingPercentage
}){
    // const [loadingRequest, setLoadingRequest] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [payrollPeriodId, setPayrollPeriodId] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [classificationId, setClassificationId] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const submit = (e) =>{
        if (!payrollPeriodId 
            || !payTypeId
            || !classificationId
        ) {
            setErrorState(true);
            return;
        }
        handleClose();
        handlePost(e);
        setErrorState(false);
        setIsPost(true);
    };

    const handleClose = () => {
        onClose();
        setPayrollPeriodId("");
        setPayTypeId("");
        setClassificationId("");
        setErrorState(false);
    };
    const apiUrlRef = useRef( domain + `/api/DateTimeRecordStaging`);
    
    const handlePost = async (event) => {
        event.preventDefault();
        const apiUrl = apiUrlRef.current + `/paytype/${payTypeId}/payrollperiod/${payrollPeriodId}/classification/${classificationId}/post`;
        let progress = 10; // Start progress at 10%
    
        // Gradually increase progress while waiting for long API calls
        const simulateLoading = (targetPercentage, intervalTime = 500) => {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (progress < targetPercentage) {
                        progress += 1; // Increase by 1% every interval
                        setLoadingPercentage(progress);
                    } else {
                        clearInterval(interval);
                        resolve(); // Stop when reaching the target percentage
                    }
                }, intervalTime); // Adjust interval time for smoother/slower increments
            });
        };

        try {
            setLoadingPercentage(10);
            setLoadingRequest(true);

            // Simulate gradual loading progress while waiting for axios.post
            simulateLoading(30, 200); // Simulate increase to 30% slowly over 200ms per step

            // Actual axios call
            await axios.post(apiUrl, null, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setLoadingPercentage(30); // Set immediate jump to 40% after axios call finishes

            await SetAuditTrail({
                setupArea: "Time Entries", 
                actionTaken: "post", 
                field: "Post Time Entries", 
                newValue: "-", 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await simulateLoading(50, 100);
            await fetchUploads();

            await simulateLoading(60, 100);
            await fetchProcessedSummary();

            await simulateLoading(70, 100);
            await fetchProcessedDetailed();

            await simulateLoading(80, 100);
            await fetchPostedSummary();

            await simulateLoading(90, 100);
            await fetchPostedDetailed();

            setShowRequestMessage(true);
            setIsSuccess(true);

            simulateLoading(95, 100);

            handleClose();
        } catch (error) {
            // Stop any ongoing simulation
            setLoadingPercentage(progress); // Stop at the current percentage
            setLoadingRequest(false); // Set the loading state to false
    
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);// Optionally simulate slow reset to 0 to show failure state
    
            await simulateLoading(0, 100); // Gradually decrease to 0 for a smoother UX
        } finally {
            // Finalize loading process and reset
            await simulateLoading(100, 100); // Gradually increment to 100% before closing
            setTimeout(() => {
                setLoadingPercentage(0);
                setLoadingRequest(false);
            }, 0); // Delay to show full completion before resetting
        }
    }

    const [currentPayTypeId, setCurrentPayTypeId] = useState("");
    useEffect(() => {
        if(currentPayTypeId !== payTypeId){
            setCurrentPayTypeId(payTypeId);
            setClassificationId("");
            setPayrollPeriodId("");
        }
    }, [currentPayTypeId, payTypeId])

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Post Time Entries</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body column" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelectFilter payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!payrollPeriodId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                                <ClassificationIdSelectFilter user={user} classificationId={classificationId} setClassificationId={setClassificationId} payTypeId={payTypeId}/>
                            </div>
                            <span style={{
                                        visibility: ((!classificationId && errorState) || !payTypeId) ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>{!payTypeId ? "Please select Pay Type first" : "Please fill up this field"}
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}
                            style={{marginRight:"5px"}}>
                                POST
                        </button>
                    </div>
                </div>
            )}
            </div>
            <GenerateMessage form={showRequestMessage}
                        message={isSuccess ? "Request Success!" : requestMessage}
                        isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {/* {loadingRequest ? (
            <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)", zIndex:"3005"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            } */}
        </>
    );
}
function DeleteAllForm({isOpen, 
    onClose, 
    handleDelete}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Delete All!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to delete all uploaded time entries?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleDelete}
                            style={{marginRight:"5px"}}>
                                DELETE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ApproveForm({isOpen, 
    onClose, 
    handleApprove}
){
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Approval!</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        <span>Are you sure you want to approve selected record/s?</span>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleApprove}
                            style={{marginRight:"5px"}}>
                                APPROVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function UploadForm({isOpen, 
    onClose,
    data_temp,
    setData_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setData_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(data_temp.length > 0){
            const _errorData = data_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [data_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setData_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(data_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Employee Id",
        "Employee Name",
        "Date",
        "Time In",
        "Device In",
        "Time Out",
        "Device Out",
        "Error",
    ]
    var accessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOut",
        "deviceNameTimeOut",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Time Entries"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={data_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function UploadFormTampered({isOpen, 
    onClose,
    data_temp,
    setData_temp,
    handleFileUpload,
    handleFinalFileUpload}
){
    const handleClose = () => {
        onClose();
        setFiles("");
        setData_temp([]);
    };

    const [files, setFiles] = useState([]);
    const [currentFiles, setCurrentFiles] = useState([]);
    const [hasNoError, setHasNoError] = useState(false);

    useEffect(() => {
        if(data_temp.length > 0){
            const _errorData = data_temp.filter(i => i.errors.length > 0)

            if(_errorData.length <= 0){
                setHasNoError(true)
            } else {
                setHasNoError(false)
            }
        }
    }, [data_temp])

    const handleBrowse = (e) => {
        const fileList = Array.from(e.target.files);
        setFiles(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const fileList = Array.from(e.dataTransfer.files);
        setFiles(fileList);
        e.currentTarget.style.backgroundColor = "white";
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "#bdbdbd7d";
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.currentTarget.style.backgroundColor = "white";
    };
    const clearFiles = () => {
        // Clear the files state
        setFiles([]);
        // Reset the value of the file input
        document.getElementById('fileInput').value = '';
        setData_temp([]);
    };

    useEffect(() => {
        if(currentFiles !== files){
            setCurrentFiles(files)
            handleFileUpload(files);
        }
    }, [files, handleFileUpload, currentFiles])

    const submit = (e) =>{
        handleFinalFileUpload(data_temp);
        handleClose();
    };

    const [currentPage, setCurrentPage] = useState(1);
    var header = [
        "Id",
        "Employee Id",
        "Employee Name",
        "Date",
        "Time In",
        "Device In",
        "Time Out",
        "Device Out",
        "Shift Name",
        "Reason For Tampering",
        "Error",
    ]
    var accessor = [
        "id",
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "date",
        "timeIn",
        "deviceNameTimeIn",
        "timeOut",
        "deviceNameTimeOut",
        "employeePersonalInformationEmployeeInformationShiftScheduleShiftName",
        "reasonForTampering",
        "errors",
    ]

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>{"Upload Tampered Time Entries"}</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>

                    <div className="popUp-body user-template-body" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                        
                    </div>

                    <div>
                        <label htmlFor="fileInput" className='browse'>Browse...</label>
                        <input
                            type="file"
                            id="fileInput"
                            onChange={(e)=> handleBrowse(e)}
                            style={{ display: 'none' }}
                        />
                        <div
                            id='drop-files-here'
                            onDrop={(e)=>handleDrop(e)}
                            onDragOver={(e)=>handleDragOver(e)}
                            onDragLeave={(e)=>handleDragOut(e)}
                            style={{
                            border: '2px dashed #ccc',
                            borderRadius: '5px',
                            padding: '20px',
                            marginTop: '10px',
                            textAlign: 'center',
                            }}
                        >
                            Drop files here
                        </div>
                        {files.length > 0 && (
                            <div style={{border:"1px solid #97979745", padding:"10px"}}>
                                <span>Uploaded File:</span>
                                <ul>
                                    {files.map((file, index) => (
                                    <span key={index}>{file.name}</span>
                                    ))}
                                </ul>
                                <div className="buttons row" style={{display:"flex", justifyContent:"end"}}>
                                    <button id="add-family" 
                                    className="cancel row"
                                    onClick={()=>clearFiles()}
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}>
                                        CLEAR
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                    {files.length > 0 && (
                        <>
                            {hasNoError ?
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#4cc92a", color: "white"}}>
                                    Data is valid.
                                </div>
                            </>
                            :
                            <>
                                <div style={{marginTop: "10px", padding: "10px", backgroundColor: "#ce3434", color: "white"}}>
                                    Cannot upload with error.
                                </div>
                            </>
                            }
                            <div className='employeesTab-tab upload-preview-tab' style={{marginTop: "10px"}}>
                                <div id="container1 table-uploads" className="employeesTab-table container">
                                    <CreateTableForUpload
                                        dataList={data_temp}
                                        dataHeader={header}
                                        dataAccessor={accessor}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                    />
                                </div>
                            </div>
                            <div className="buttons row" style={{justifyContent:"end", padding:"40px 40px 20px 40px"}}>
                                {hasNoError && <button id="add-family" 
                                    className="save row"
                                    onClick={(e)=>submit(e)}
                                    style={{marginRight:"5px"}}>
                                        UPLOAD
                                </button>}
                                <button id="add-family" 
                                    className="cancel row"
                                    style={{marginRight:"5px", height: "34px", borderRadius: "3px"}}
                                    onClick={()=>handleClose()}>
                                        CANCEL
                                </button>
                            </div>
                        </>
                        )
                    }
                    
                    
                </div>
            )}
            </div>
        </>
    );
}
function AddEmployeeGroup2LogsForm({
    isOpen, 
    onClose,
    employeeGroup2Id,
    setEmployeeGroup2Id,
    employeeGroup2DateFrom,
    setEmployeeGroup2DateFrom,
    employeeGroup2DateTo,
    setEmployeeGroup2DateTo,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!employeeGroup2Id
            || !employeeGroup2DateFrom
            || !employeeGroup2DateTo
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setEmployeeGroup2Id("");
        setErrorState(false);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Employee Group 2 Logs</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee Group 2</div>
                            <div className="info-item-input">
                                <EmployeeGroup2IdSelect employeeGroup2Id={employeeGroup2Id} setEmployeeGroup2Id={setEmployeeGroup2Id}/>
                            </div>
                            <span style={{
                                        visibility: !employeeGroup2Id && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateInput date={employeeGroup2DateFrom} setDate={setEmployeeGroup2DateFrom}/>
                            </div>
                            <span style={{
                                        visibility: !employeeGroup2DateFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateInput date={employeeGroup2DateTo} setDate={setEmployeeGroup2DateTo}/>
                            </div>
                            <span style={{
                                        visibility: !employeeGroup2DateTo && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                ADD
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function ExtractForm({
    isOpen, 
    onClose,
    payrollPeriodId,
    setPayrollPeriodId,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!payrollPeriodId){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
        setPayrollPeriodId("");
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Extract Form</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Payroll Period</div>
                            <div className="info-item-input">
                                <PayrollPeriodIdSelect payrollPeriodId={payrollPeriodId} setPayrollPeriodId={setPayrollPeriodId}/>
                            </div>
                            <span style={{
                                        visibility: !payrollPeriodId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                EXTRACT
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function EditBtn(cell)
{
    var editTabHolder = document.getElementById("editTabHolder")
    if(editTabHolder !== null){
        editTabHolder.style.display = "block";
    }

    var employee = document.getElementById("employeeEdit");
    var timeIn = document.getElementById("datetime-in-edit");
    var timeOut = document.getElementById("datetime-out-edit");
    var timeInDevice = document.getElementById("timeInDevEdit");
    var timeOutDevice = document.getElementById("timeOutDevEdit");
    employee.value = cell.employee;
    timeIn.value = cell.date + "T" + cell.timeIn;
    timeOut.value = cell.date + "T" + cell.timeOut;
    timeInDevice.value = cell.timeInDevice;
    timeOutDevice.value = cell.timeOutDevice;
};
function PayrollPeriodIdSelect({payrollPeriodId, setPayrollPeriodId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose payroll period</option>
            {data.map((payrollPeriodId) => ( 
                SetPayrollPeriodId(payrollPeriodId)
            ))}
            </select>
        </div>
    );
};
function PayrollPeriodIdSelectFilter({payrollPeriodId, setPayrollPeriodId, payTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayrollPeriodId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        if(!payTypeId){
            return;
        }
        // const currentYear = new Date().getFullYear();
        // const apiUrl =  domain + `/api/PayrollPeriod/year/${currentYear}`;
        const apiUrl =  domain + `/api/PayrollPeriod/active/paytype/${payTypeId}`; // changed

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data);
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [payTypeId]);

    useEffect(() => {
        fetchData();
        if(payrollPeriodId !== "" && payrollPeriodId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, payrollPeriodId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={!payTypeId} value={payrollPeriodId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose payroll period</option>
                {data.map((payrollPeriodId) => ( 
                    SetPayrollPeriodId(payrollPeriodId)
                ))}
            </select>
        </div>
    );
};
function SetPayrollPeriodId(payrollPeriodId){
    const formattedDateFrom = format(payrollPeriodId.dateFrom, 'MM/dd/yyyy');
    const formattedDateTo = format(payrollPeriodId.dateTo, 'MM/dd/yyyy');

    return(
        <option value={payrollPeriodId.id}>{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription ? payrollPeriodId.payTypeDescription : ""}`}
        </option>
    )
}
function EmployeeGroup1IdSelect({employeeGroup1Id, setEmployeeGroup1Id}){
    
    const handleSelectChange = (event) => {
        setEmployeeGroup1Id(Number(event.target.value));
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/EmployeeGroup1/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={employeeGroup1Id || ""} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)"}}>
            <option value="" >All</option>
            {data.map((employeeGroup1Id) => ( 
                SetEmployeeGroup1Id(employeeGroup1Id)
            ))}
            </select>
        </div>
    );
};
function SetEmployeeGroup1Id(employeeGroup1Id){
    return(
        <option value={employeeGroup1Id.id}>{
            employeeGroup1Id.description}
        </option>
    )
    
}
function EmployeeGroup2IdSelect({employeeGroup2Id, setEmployeeGroup2Id}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setEmployeeGroup2Id(Number(event.target.value));
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/EmployeeGroup2/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(employeeGroup2Id !== "" && employeeGroup2Id !== 0 && employeeGroup2Id !== null && employeeGroup2Id !== undefined){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [employeeGroup2Id]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={employeeGroup2Id || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose employee group 2</option>
            {data.map((employeeGroup2Id) => ( 
                SetEmployeeGroup2Id(employeeGroup2Id)
            ))}
            </select>
        </div>
    );
};
function SetEmployeeGroup2Id(employeeGroup2Id){
    return(
        <option value={employeeGroup2Id.id}>{
            employeeGroup2Id.description}
        </option>
    )
    
}
function LogTypeSelect({logType, setLogType}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setLogType(event.target.value);
    };

    useEffect(() => {
        if(logType !== "" && logType !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [logType]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={logType} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="Sentry Biometrics">Sentry Biometrics</option>
            <option value="Mobile Biometrics">Mobile Biometrics</option>
            </select>
        </div>
    );
};
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== "" && payTypeId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {data.map((payTypeId) => ( 
                SetPayTypeId(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeId(payTypeId){
    return(
        <option value={payTypeId.id}>{
            payTypeId.description}
        </option>
    )
    
}
function ClassificationIdSelectDummy(){
    return (
        <div>
            <select id="employee-select-PagibigReport">
            </select>
        </div>
    );
};
function ClassificationIdSelect({classificationId, setClassificationId, user}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Classification/active/username/${user.username}`;

        try {
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

            setData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [user]);

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectFilter({classificationId, setClassificationId, payTypeId, user}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        if(!payTypeId){
            return;
        }
        
        const apiUrl =  domain + `/api/Classification/active/username/${user.username}`;

        try {
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})

            let finalData = response.data;
            
            if(parseInt(payTypeId) === 1){
                finalData = response.data.filter(i => i.id === 1);
            } else if(parseInt(payTypeId) === 3){
                finalData = response.data.filter(i => i.id === 2 || i.id === 3 || i.id === 4);
            }

            setData(finalData); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, [payTypeId, user]);

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [fetchData, classificationId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" disabled={!payTypeId} value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose classification</option>
            {data.map((classificationId) => ( 
                SetClassificationId(classificationId)
            ))}
            </select>
        </div>
    );
};
function ClassificationIdSelectWithAll1({classificationId, setClassificationId, setActiveRowIds, setSelectedDTR, user}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setClassificationId(event.target.value);

        if(setActiveRowIds && setSelectedDTR){
            setActiveRowIds([]);
            setSelectedDTR([]);
        }
    };

    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Classification/active/username/${user.username}`;

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [user])

    useEffect(() => {
        fetchData();
        if(classificationId !== "" && classificationId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [classificationId, fetchData]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={classificationId} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose classification</option>
                {data.length > 0 && <option value="0">All</option>}
                {data.map((classificationId) => ( 
                    SetClassificationId(classificationId)
                ))}
            </select>
        </div>
    );
};
function SetClassificationId(classificationId){
    return(
        <option value={classificationId.id}>{
            classificationId.description}
        </option>
    )
}
function SectionIdSelect({sectionId, setSectionId}){
    
    const handleSelectChange = (event) => {
        setSectionId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Section/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={sectionId} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="0" >All</option>
            {data.map((sectionId) => ( 
                SetSectionId(sectionId)
            ))}
            </select>
        </div>
    );
};
function SetSectionId(sectionId){
    return(
        <option value={sectionId.id}>{
            sectionId.description}
        </option>
    )
    
}
function LocationIdSelect({locationId, setLocationId}){
    const handleSelectChange = (event) => {
        setLocationId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Location/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.description.localeCompare(b.description));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={locationId} onChange={handleSelectChange}style={{ height: "30px", color: "rgb(104, 104, 104)"}}>
            <option value="0" >All</option>
            {data.map((locationId) => ( 
                SetLocationId(locationId)
            ))}
            </select>
        </div>
    );
};
function SetLocationId(locationId){
    return(
        <option value={locationId.id}>{
            locationId.description}
        </option>
    )

}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    userAccessData
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesInfo, setEmployeesInfo] = useState([]);
    const [allEmployeesBasicInfo, setAllEmployeesBasicInfo] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("0");
    const [currentClassificationFilter, setCurrentClassificationFilter] = useState("");

    /* const fetchDataAllData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee";
        try {
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    }, []); */

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/Employee/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            // const employeeAllData = await fetchDataAllData();
            setEmployeesInfo(response.data);
            setAllEmployeesBasicInfo(response.data);
            setEmployees(response.data);
            setFilterData(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(()=>{
        let classifiedData = allEmployeesBasicInfo;
        let classificiationFilter = classificationFilterForAdminHRHead;

        setCurrentClassificationFilter(classificiationFilter);

        if(classificiationFilter !== "0" && classificiationFilter !== "All"){
            const _classified = allEmployeesBasicInfo.filter(employee => {
                const foundEmployee = employeesInfo.find(_employee => _employee.employeeId === employee.employeeId);
                
                if (foundEmployee.employeeInformation && foundEmployee.employeeInformation.classificationId) {
                    return foundEmployee.employeeInformation.classificationId.toString() === classificiationFilter;
                }
                return false;
            });
            
            classifiedData = _classified;
        }

        if(classificiationFilter !== currentClassificationFilter){
            setEmployees(classifiedData);
            setFilterData(classifiedData);
        }
    }, [
        classificationFilterForAdminHRHead,
        currentClassificationFilter,
        employees,
        employeesInfo,
        allEmployeesBasicInfo,
    ])
    
    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [fetchData, filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="transaction-body">
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{padding: "0 10px 20px 10px", justifyContent: "normal"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Filter</div>
                                        <div className="info-item-input">
                                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                                        </div>
                                    </div>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Classification Type</div>
                                        <div className="info-item-input">
                                            <ClassificationIdSelectWithAll1 classificationId={classificationFilterForAdminHRHead} setClassificationId={setClassificationFilterForAdminHRHead}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange} style={{color: "rgb(104, 104, 104)"}}>
            <option value="All">All</option>
            <option value="EmployeeId">Employee Id</option>
        </select>
    );
};
function EmployeeSelectFormLogs({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
    setEmployeeInfo
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        // setEmployeeInfo(selectedEmployee);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilterLogs setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilterLogs({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="datetime-local"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function DateInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={date}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function TimeDevice({device, setDevice}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setDevice(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Device";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(device !== "" && device !== 0 && device !== null && device !== undefined){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [device]);

    return (
        <div>
            <select id="" className="filterSelect" value={device} onChange={handleSelectChange} style={{color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
                <option value="" disabled hidden>Choose a device</option>
                {data.map((device) => ( 
                    SetTimeDevice(device)
                ))}
            </select>
        </div>
    );
};
function SetTimeDevice(device){
    return(
        <option value={device.name}>{
            device.name}
        </option>
    )
}
function FilterHeaderSummaryForm({isOpen, 
    onClose, 
    setFilteredHeaderForSummary,
    }
){
    var processedTimeEntriesHeaderSummary = [
        "Id",
        "Employee Id",
        "Name",
        "Payroll Period",
        "Pay Type",
        "Date Processed",
        "Total Days",
        "Total Absents",
        "Total Late",
        "Total Undertime",
        "Total Leaves",
        "Total Night Diff",
        "Total OT Regular",
        "Total OT Regular Exceed",
        "Total OT Restday",
        "Total OT Restday Exceed",
        "Total OT Holiday Special",
        "Total Holiday Special Exceed",
        "Total OT Holiday Regular",
        "Total Holiday Regular Exceed",
        "Total OT Restday Holiday Special",
        "Total Restday Holiday Special Exceed",
        "Total OT Restday Holiday Regular",
        "Total Restday Holiday Regular Exceed",
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Filter Header Form (Summary)</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body filter-header-popUp">
                        <div id='summary-table' className="timeTable container">
                            <CreateTableForFilterHeaderSummary
                                dataHeader={processedTimeEntriesHeaderSummary}
                                setFilteredHeaderForSummary={setFilteredHeaderForSummary}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        {/* <button id="add-family" 
                            className="save row"
                            onClick={confirmationHandleClick}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button> */}
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function FilterHeaderDetailedForm({isOpen, 
    onClose, 
    setFilteredHeaderForDetailed}
){
    var processedTimeEntriesHeaderDetailed = [
        "Id",
        "Employee Id",
        "Name",
        "Date",
        "Time In",
        "Time Out",
        "Late",
        "Undertime",
        "Night Diff",
        "OT Regular",
        "OT Regular Exceed",
        "OT Restday",
        "OT Restday Exceed",
        "OT Holiday Special",
        "Holiday Special Exceed",
        "OT Holiday Regular",
        "Holiday Regular Exceed",
        "OT Restday Holiday Special",
        "Restday Holiday Special Exceed",
        "OT Restday Holiday Regular",
        "Restday Holiday Regular Exceed"
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Filter Header Form (Detailed)</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body filter-header-popUp">
                        <div id='summary-table' className="timeTable container">
                            <CreateTableForFilterHeaderDetailed
                                dataHeader={processedTimeEntriesHeaderDetailed}
                                setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        {/* <button id="add-family" 
                            className="save row"
                            onClick={handleSave}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button> */}
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function FilterHeaderPostedSummaryForm({isOpen, 
    onClose, 
    setFilteredHeaderForSummary,
    }
){
    var processedTimeEntriesHeaderSummary = [
        "Id",
        "Employee Id",
        "Name",
        "Payroll Period",
        "Pay Type",
        "Date Processed",
        "Total Days",
        "Total Absents",
        "Total Late",
        "Total Undertime",
        "Total Leaves",
        "Total Night Diff",
        "Total OT Regular",
        "Total OT Regular Exceed",
        "Total OT Restday",
        "Total OT Restday Exceed",
        "Total OT Holiday Special",
        "Total Holiday Special Exceed",
        "Total OT Holiday Regular",
        "Total Holiday Regular Exceed",
        "Total OT Restday Holiday Special",
        "Total Restday Holiday Special Exceed",
        "Total OT Restday Holiday Regular",
        "Total Restday Holiday Regular Exceed",
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Filter Header Form (Summary)</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body filter-header-popUp">
                        <div id='summary-table' className="timeTable container">
                            <CreateTableForFilterHeaderPostedSummary
                                dataHeader={processedTimeEntriesHeaderSummary}
                                setFilteredHeaderForSummary={setFilteredHeaderForSummary}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        {/* <button id="add-family" 
                            className="save row"
                            onClick={confirmationHandleClick}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button> */}
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function FilterHeaderPostedDetailedForm({isOpen, 
    onClose, 
    setFilteredHeaderForDetailed}
){
    var processedTimeEntriesHeaderDetailed = [
        "Id",
        "Employee Id",
        "Name",
        "Date",
        "Time In",
        "Time Out",
        "Late",
        "Undertime",
        "Night Diff",
        "OT Regular",
        "OT Regular Exceed",
        "OT Restday",
        "OT Restday Exceed",
        "OT Holiday Special",
        "Holiday Special Exceed",
        "OT Holiday Regular",
        "Holiday Regular Exceed",
        "OT Restday Holiday Special",
        "Restday Holiday Special Exceed",
        "OT Restday Holiday Regular",
        "Restday Holiday Regular Exceed"
    ]

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Filter Header Form (Detailed)</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body filter-header-popUp">
                        <div id='summary-table' className="timeTable container">
                            <CreateTableForFilterHeaderPostedDetailed
                                dataHeader={processedTimeEntriesHeaderDetailed}
                                setFilteredHeaderForDetailed={setFilteredHeaderForDetailed}
                            />
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                        {/* <button id="add-family" 
                            className="save row"
                            onClick={handleSave}
                            style={{marginRight:"5px"}}>
                                SAVE
                        </button>
                        <button id="add-family" 
                            className="cancel row"
                            onClick={()=>handleClose()}>
                                CANCEL
                        </button> */}
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function GenerateMessage({form, message, isSuccess}){
    return (
        <>
            <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                {form && (
                <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                    <div className='column'>
                        {isSuccess ?
                            <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                <CheckCircleIcon/>
                                <span >{"SUCCESS MESSAGE"}</span>
                            </div>
                            :
                            <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                <ErrorIcon/>
                                <span>{"ERROR MESSAGE"}</span>
                            </div>
                        }
                        <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
export function CreateTable({
    dataList = [],
    dataHeader = [],
    dataAccessor = [],
    currentPage,
    setCurrentPage,
    editHandleClick,
    deleteHandleClick,
    setSelected,
    employees,
    isSelectAll,
    setIsSelectAll,
    activeRowIds,
    setActiveRowIds
}) {
    const itemsPerPage = 10;

    // Define table columns
    const columns = React.useMemo(
        () =>
            dataHeader.map((header, index) => ({
                Header: header,
                accessor: dataAccessor[index],
            })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Select all logic
    useEffect(() => {
        if (isSelectAll) {
            const newActiveRowIds = rows.map((item) => item.original.id);
            const newActiveRowOriginal = rows.map((item) => item.original);
            setActiveRowIds(newActiveRowIds);
            setSelected(newActiveRowOriginal);
            setIsSelectAll(false);
        }
    }, [isSelectAll, setIsSelectAll, setSelected, rows, setActiveRowIds]);

    // Row click handler
    const handleRowClick = (rowData) => {
        setSelected((prevSelected) => {
            const isAlreadySelected = prevSelected.some(
                (item) => item.id === rowData.id
            );
            return isAlreadySelected
                ? prevSelected.filter((item) => item.id !== rowData.id)
                : [...prevSelected, rowData];
        });

        setActiveRowIds((prevIds) =>
            prevIds.includes(rowData.id)
                ? prevIds.filter((id) => id !== rowData.id)
                : [...prevIds, rowData.id]
        );
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className="scrollable-table">
                <table {...getTableProps()} className='border-collapse'>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps()}
                                        onClick={() => headerClick(column)}
                                        className="sortable-header"
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row);
                            return (
                                <tr
                                    key={row.original.id}
                                    {...row.getRowProps()}
                                    onClick={() =>
                                        handleRowClick(row.original)
                                    }
                                    className={
                                        activeRowIds.includes(row.original.id)
                                            ? "active"
                                            : ""
                                    }
                                    id={
                                        row.original.reasonForTampering
                                            ? "tampered"
                                            : ""
                                    }
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo
                                            header={cell.render("Cell").props.column.Header}
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                        />
                                    ))}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            {rows.length > itemsPerPage ? (
                <>
                    <div
                        className="table-page row"
                        style={{
                            alignItems: "center",
                            justifyContent: "end",
                            padding: "20px 0 0 0",
                        }}
                    >
                        <button
                            className="prev row"
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            &lt;&lt;
                        </button>
                        <button
                            className="prev row"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={{
                                visibility:
                                    currentPage === 1 ? "hidden" : "visible",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            PREVIOUS
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                marginRight: "5px",
                                height: "26px",
                            }}
                        >
                            NEXT
                        </button>
                        <button
                            className="next row"
                            onClick={() => paginate(totalPages)}
                            disabled={indexOfLastItem >= rows.length}
                            style={{
                                visibility:
                                    rows.length > itemsPerPage && !isLastPage
                                        ? "visible"
                                        : "hidden",
                                height: "26px",
                            }}
                        >
                            &gt;&gt;
                        </button>
                    </div>
                    <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                        {`${currentPage}/${totalPages}`}
                    </div>
                </>
            ) : (
                <></>
            )}
        </>
    );
}
export function CreateTableWithHeaderDragSummary({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, setSelected, employees, handleDragStart, filteredHeaderForSummary, viewLeaveHandleClick }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [updatedDataHeader, setUpdatedDataHeader] = useState(dataHeader);
    const [updatedDataAccessor, setUpdatedDataAccessor] = useState(dataAccessor);

    useEffect(() => {
        let itemsToRemove = [];
        
        if (filteredHeaderForSummary && filteredHeaderForSummary.length > 0) {
            itemsToRemove = filteredHeaderForSummary.map(item => item.textContent);
        }
        
        const removedItemIndexes = [];
        const newUpdatedDataHeader = dataHeader.filter((item, index) => {
            if (itemsToRemove.includes(item)) {
                removedItemIndexes.push(index);
                return false; // Exclude the item from the filtered array
            }
            return true; // Include the item in the filtered array
        });
        const newDataAccessor = dataAccessor.filter((_, index) => !removedItemIndexes.includes(index));
        setUpdatedDataHeader(newUpdatedDataHeader);
        setUpdatedDataAccessor(newDataAccessor);
    }, [dataHeader, dataAccessor, filteredHeaderForSummary]);

    const columns = React.useMemo(() =>
        updatedDataHeader.map((header, index) => ({
            Header: header,
            accessor: updatedDataAccessor[index]
        })),
        [updatedDataHeader, updatedDataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className='scrollable-table'>
                <table {...getTableProps()} className='border-collapse'>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}
                                    className='draggable-header sortable-header'
                                    draggable
                                    onDragStart={(e)=>handleDragStart(e, column.render("Header"))}
                                    onClick={() => headerClick(column)}
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                            viewLeaveHandleClick={viewLeaveHandleClick}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                    {`${currentPage}/${totalPages}`}
                </div>
            </>
            ) :
            <></>}
        </>
    )
}
export function CreateTableWithHeaderDragDetailed({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, editHandleClick, deleteHandleClick, setSelected, employees, handleDragStart, filteredHeaderForDetailed, viewLeaveHandleClick }) {
    // const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [updatedDataHeader, setUpdatedDataHeader] = useState(dataHeader);
    const [updatedDataAccessor, setUpdatedDataAccessor] = useState(dataAccessor);

    useEffect(() => {
        let itemsToRemove = [];
        
        if (filteredHeaderForDetailed && filteredHeaderForDetailed.length > 0) {
            itemsToRemove = filteredHeaderForDetailed.map(item => item.textContent);
        }
        
        const removedItemIndexes = [];
        const newUpdatedDataHeader = dataHeader.filter((item, index) => {
            if (itemsToRemove.includes(item)) {
                removedItemIndexes.push(index);
                return false; // Exclude the item from the filtered array
            }
            return true; // Include the item in the filtered array
        });
        const newDataAccessor = dataAccessor.filter((_, index) => !removedItemIndexes.includes(index));
        setUpdatedDataHeader(newUpdatedDataHeader);
        setUpdatedDataAccessor(newDataAccessor);
    }, [dataHeader, dataAccessor, filteredHeaderForDetailed]);

    const columns = React.useMemo(() =>
        updatedDataHeader.map((header, index) => ({
            Header: header,
            accessor: updatedDataAccessor[index]
        })),
        [updatedDataHeader, updatedDataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <>
            <div className='scrollable-table'>
                <table {...getTableProps()} className='border-collapse'>
                    <thead>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th {...column.getHeaderProps()}
                                    className='draggable-header sortable-header'
                                    draggable
                                    onDragStart={(e)=>handleDragStart(e, column.render("Header"))}
                                    onClick={() => headerClick(column)}
                                    >
                                        {`${column.render("Header")} ${
                                            sortHeaderValue.id === column.id
                                                ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                                : ""
                                        }`}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {dataList.length <= 0 &&
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                    No data to display
                                </td>
                            </tr>
                        }
                        {currentItems.map((row) => {
                            prepareRow(row)
                            return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfo header={cell.render("Cell").props.column.Header} 
                                            _cell={cell}
                                            editHandleClick={editHandleClick}
                                            deleteHandleClick={deleteHandleClick}
                                            employees={employees}
                                            viewLeaveHandleClick={viewLeaveHandleClick}
                                        />
                                    ))}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                    {`${currentPage}/${totalPages}`}
                </div>
            </>
            ) :
            <></>}
        </>
    )
}
export function CreateTableForEmployeeSelect({ dataList = [], dataHeader = [], dataAccessor = [], currentPage, setCurrentPage, setSelectedEmployee}) {
    // const [currentPage, setCurrentPage] = useState(1);
    const [activeRowId, setActiveRowId] = useState(null);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleRowClick = (rowData) => {
        setSelectedEmployee(rowData); // Pass the clicked row data to the setSelectedEmployee function
        setActiveRowId(rowData.id);
    };

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            onClick={() => handleRowClick(row.original)} // Attach onClick event handler to the row
                            className={row.original.id === activeRowId ? 'active' : ''}
                            >
                                {row.cells.map((cell) => (
                                    <SetInfo header={cell.render("Cell").props.column.Header} 
                                        _cell={cell}/>
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px"}}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px"}}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"center", padding: "20px 0 0 0"}}>
                    {`${currentPage}/${totalPages}`}
                </div>
            </div>
            ) :
            <></>}
        </div>
    )
}
function CreateTableForFilterHeaderSummary({ dataHeader = [], setFilteredHeaderForSummary }) {
    const thRefs = useRef([]);
    const [checkedState, setCheckedState] = useState({});

    useEffect(() => {
        const initialCheckedState = {};
        dataHeader.forEach((header, index) => {
            initialCheckedState[header] = localStorage.getItem(`processedSummary${formatString(header)}`) === 'true';
        });
        setCheckedState(initialCheckedState);
    }, [dataHeader]);

    function formatString(inputString) {
        const words = inputString.split(' ');
        const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
        return formattedString;
    }

    const checkHandler = (header, checked, index) => {
        const thElement = thRefs.current[index];

        setCheckedState(prevState => ({
            ...prevState,
            [header]: checked
        }));

        setFilteredHeaderForSummary(prevFilteredHeader => {
            let updatedFilteredHeader = [...prevFilteredHeader];

            if (checked) {
                if (!updatedFilteredHeader.some(item => item.isEqualNode(thElement))) {
                    updatedFilteredHeader.push(thElement);
                }
            } else {
                updatedFilteredHeader = updatedFilteredHeader.filter(item => !item.isEqualNode(thElement));
            }

            const headerTextArray = updatedFilteredHeader.map(thElement => thElement.textContent);
            const headerText = Array.isArray(headerTextArray) ? headerTextArray : [headerTextArray];

            localStorage.setItem('processedSummaryFilteredHeader', JSON.stringify(headerText));

            return updatedFilteredHeader;
        });

        localStorage.setItem(`processedSummary${formatString(header)}`, checked.toString());
    };

    return (
        <div className='scrollable-table'>
            <table>
                <thead>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <th key={index} ref={el => thRefs.current[index] = el}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <td key={index}>
                                <input type="checkbox"
                                    checked={!checkedState[header] ?? false}
                                    onChange={(e) => checkHandler(header, !e.target.checked, index)} />
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
function CreateTableForFilterHeaderDetailed({ dataHeader = [], setFilteredHeaderForDetailed}) {
    const thRefs = useRef([]);
    const [checkedState, setCheckedState] = useState({});

    useEffect(() => {
        const initialCheckedState = {};
        dataHeader.forEach((header, index) => {
            initialCheckedState[header] = localStorage.getItem(`processedDetailed${formatString(header)}`) === 'true';
        });
        setCheckedState(initialCheckedState);
    }, [dataHeader]);

    function formatString(inputString) {
        const words = inputString.split(' ');
        const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
        return formattedString;
    }

    const checkHandler = (header, checked, index) => {
        const thElement = thRefs.current[index];

        setCheckedState(prevState => ({
            ...prevState,
            [header]: checked
        }));

        setFilteredHeaderForDetailed(prevFilteredHeader => {
            let updatedFilteredHeader = [...prevFilteredHeader];

            if (checked) {
                if (!updatedFilteredHeader.some(item => item.isEqualNode(thElement))) {
                    updatedFilteredHeader.push(thElement);
                }
            } else {
                updatedFilteredHeader = updatedFilteredHeader.filter(item => !item.isEqualNode(thElement));
            }

            const headerTextArray = updatedFilteredHeader.map(thElement => thElement.textContent);
            const headerText = Array.isArray(headerTextArray) ? headerTextArray : [headerTextArray];

            localStorage.setItem('processedDetailedFilteredHeader', JSON.stringify(headerText));

            return updatedFilteredHeader;
        });

        localStorage.setItem(`processedDetailed${formatString(header)}`, checked.toString());
    };

    return (
        <div className='scrollable-table'>
            <table>
                <thead>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <th key={index} ref={el => thRefs.current[index] = el}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <td key={index}>
                                <input type="checkbox"
                                    checked={!checkedState[header] ?? false}
                                    onChange={(e) => checkHandler(header, !e.target.checked, index)} />
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
function CreateTableForFilterHeaderPostedSummary({ dataHeader = [], setFilteredHeaderForSummary }) {
    const thRefs = useRef([]);
    const [checkedState, setCheckedState] = useState({});

    useEffect(() => {
        const initialCheckedState = {};
        dataHeader.forEach((header, index) => {
            initialCheckedState[header] = localStorage.getItem(`postedSummary${formatString(header)}`) === 'true';
        });
        setCheckedState(initialCheckedState);
    }, [dataHeader]);

    function formatString(inputString) {
        const words = inputString.split(' ');
        const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
        return formattedString;
    }

    const checkHandler = (header, checked, index) => {
        const thElement = thRefs.current[index];

        setCheckedState(prevState => ({
            ...prevState,
            [header]: checked
        }));

        setFilteredHeaderForSummary(prevFilteredHeader => {
            let updatedFilteredHeader = [...prevFilteredHeader];

            if (checked) {
                if (!updatedFilteredHeader.some(item => item.isEqualNode(thElement))) {
                    updatedFilteredHeader.push(thElement);
                }
            } else {
                updatedFilteredHeader = updatedFilteredHeader.filter(item => !item.isEqualNode(thElement));
            }

            const headerTextArray = updatedFilteredHeader.map(thElement => thElement.textContent);
            const headerText = Array.isArray(headerTextArray) ? headerTextArray : [headerTextArray];

            localStorage.setItem('postedSummaryFilteredHeader', JSON.stringify(headerText));

            return updatedFilteredHeader;
        });

        localStorage.setItem(`postedSummary${formatString(header)}`, checked.toString());
    };

    return (
        <div className='scrollable-table'>
            <table>
                <thead>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <th key={index} ref={el => thRefs.current[index] = el}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <td key={index}>
                                <input type="checkbox"
                                    checked={!checkedState[header] ?? false}
                                    onChange={(e) => checkHandler(header, !e.target.checked, index)} />
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
function CreateTableForFilterHeaderPostedDetailed({ dataHeader = [], setFilteredHeaderForDetailed}) {
    const thRefs = useRef([]);
    const [checkedState, setCheckedState] = useState({});

    useEffect(() => {
        const initialCheckedState = {};
        dataHeader.forEach((header, index) => {
            initialCheckedState[header] = localStorage.getItem(`postedDetailed${formatString(header)}`) === 'true';
        });
        setCheckedState(initialCheckedState);
    }, [dataHeader]);

    function formatString(inputString) {
        const words = inputString.split(' ');
        const formattedString = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');
        return formattedString;
    }

    const checkHandler = (header, checked, index) => {
        const thElement = thRefs.current[index];

        setCheckedState(prevState => ({
            ...prevState,
            [header]: checked
        }));

        setFilteredHeaderForDetailed(prevFilteredHeader => {
            let updatedFilteredHeader = [...prevFilteredHeader];

            if (checked) {
                if (!updatedFilteredHeader.some(item => item.isEqualNode(thElement))) {
                    updatedFilteredHeader.push(thElement);
                }
            } else {
                updatedFilteredHeader = updatedFilteredHeader.filter(item => !item.isEqualNode(thElement));
            }

            const headerTextArray = updatedFilteredHeader.map(thElement => thElement.textContent);
            const headerText = Array.isArray(headerTextArray) ? headerTextArray : [headerTextArray];

            localStorage.setItem('postedDetailedFilteredHeader', JSON.stringify(headerText));

            return updatedFilteredHeader;
        });

        localStorage.setItem(`postedDetailed${formatString(header)}`, checked.toString());
    };

    return (
        <div className='scrollable-table'>
            <table>
                <thead>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <th key={index} ref={el => thRefs.current[index] = el}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {dataHeader.map((header, index) => (
                            <td key={index}>
                                <input type="checkbox"
                                    checked={!checkedState[header] ?? false}
                                    onChange={(e) => checkHandler(header, !e.target.checked, index)} />
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
function SetInfo({header, _cell, editHandleClick, deleteHandleClick, viewLeaveHandleClick}) {
    const data = _cell.render("Cell").props.row.original;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                </div>
            </td>
        )
    }

    if (header === "Total Leaves") {
        const value = _cell.render("Cell").props.value

        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        return (
            <td className="px-4 py-2">
                <div className="flex flex-col">
                    <span className="text-gray-600">{isNumber ? numberWithCommasAndDecimal(value) : "0.00"}</span>
                    {value && value > 0 && viewLeaveHandleClick ? 
                        <button 
                            className="
                                mt-1
                                text-xs
                                font-medium
                                rounded-sm
                                cursor-pointer
                                underline-offset-2underline
                                px-2 py-1
                                text-sky-600
                                border border-sky-600
                                bg-white

                                hover:bg-sky-600
                                hover:text-white
                            "
                            onClick={(e) => {
                                e.stopPropagation();
                                viewLeaveHandleClick(data)
                            }}
                        >
                            View Details
                        </button>
                        :
                        <></>
                    }
                </div>
            </td>
        )
    }

    /* if (header === "Device") {
        return (
            <td></td>
        )
    } */

    if(header === "Status"){
        if(data.isActive){  
            return(
                <td>
                    Active
                </td>
            )
        }
        else{
            return(
                <td>
                    InActive
                </td>
            )
        }
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    ){
        let date = new Date(_cell.render("Cell").props.value);

        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours OT Holiday Special"
    || header === "Total OT Holiday Special"
    || header === "Hours OT Holiday Regular"
    || header === "Total OT Holiday Regular"
    || header === "Hours OT Restday Holiday Special"
    || header === "Total OT Restday Holiday Special"
    || header === "Hours OT Restday Holiday Regular"
    || header === "Total OT Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "Night Diff OT"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "OT Holiday Special"
    || header === "OT Holiday Regular"
    || header === "OT Restday Holiday Special"
    || header === "OT Restday Holiday Regular"
    || header === "Total Days Regular Holidays"
    || header === "Total Regular Holidays Worked"
    || header === "Total Days Special Non-Working Holidays"
    || header === "Total Special Non-Working Holidays Worked"
    || header === "Total Days"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Night Diff OT"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            case "EmployeeName":
                setFilterDataIndex(2);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
                <option value="EmployeeName">Employee Name</option>
            </select>
        </div>
    );
};
function CustomLoader({loadingPercentage}) {
    return (
        <div style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "#ffffff59", // Overlay effect
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }}>
            {loadingPercentage !== 0 && <p style={{color: "rgb(104, 104, 104)"}}>{`Loading: ${loadingPercentage}%`}</p>}
            
            <div className="custom-loader">
                <div
                    style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    height: "100%",
                    width: `${loadingPercentage}%`, // Foreground loader showing progress
                    backgroundColor: "rgba(255, 255, 255, 0.8)", // Semi-transparent to let the animation show behind it
                    borderRadius: "inherit"
                    }}
                />
            </div>
        </div>
    );
};
function CreateTableForUpload({ dataList = [], 
    dataHeader = [], 
    dataAccessor = [],
    currentPage, setCurrentPage,
}) {
    const itemsPerPage = 7;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const [sortHeaderValue, setSortHeaderValue] = useState({ id: "", desc: false, isDefault: true });

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        setSortBy
    } = useTable(
        {
            columns,
            data: dataList,
            initialState: {
                sortBy: sortHeaderValue.isDefault
                    ? []  // No sorting if it's default
                    : [{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }] // Apply sorting if not default
            }
        },
        useSortBy
    );

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    //Sorting Feature
    const sortState = [
        { id: 0, state: "default", textValue: "" },
        { id: 1, state: "ascending", textValue: "↑" },
        { id: 2, state: "descending", textValue: "↓" }
    ];

    const headerClick = (column) => {
        if (sortHeaderValue.id !== column.id) {
            // New column selected, start with ascending order
            setSortHeaderValue({ id: column.id, desc: false, isDefault: false });
            setSortBy([{ id: column.id, desc: false }]);
        } else {
            // Toggle between sorting states (default -> ascending -> descending -> default)
            if (sortHeaderValue.isDefault) {
                setSortHeaderValue({ id: column.id, desc: false, isDefault: false }); // Ascending
                setSortBy([{ id: column.id, desc: false }]);
            } else if (!sortHeaderValue.desc) {
                setSortHeaderValue({ id: column.id, desc: true, isDefault: false }); // Descending
                setSortBy([{ id: column.id, desc: true }]);
            } else {
                setSortHeaderValue({ id: "", desc: false, isDefault: true }); // Default (no sorting)
                setSortBy([]); // Clear sorting
            }
        }
    };

    // Ensure sorting is reapplied on dataList reload
    useEffect(() => {
        if (!sortHeaderValue.isDefault && sortHeaderValue.id) {
            setSortBy([{ id: sortHeaderValue.id, desc: sortHeaderValue.desc }]);
        }
    }, [dataList, setSortBy, sortHeaderValue]);

    return (
        <div>
            <table {...getTableProps()} className='border-collapse'>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th
                                {...column.getHeaderProps()}
                                onClick={() => headerClick(column)}
                                className="sortable-header"
                            >
                                {`${column.render("Header")} ${
                                    sortHeaderValue.id === column.id
                                        ? sortState[sortHeaderValue.isDefault ? 0 : sortHeaderValue.desc ? 2 : 1].textValue
                                        : ""
                                }`}
                            </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                                <tr key={row.original.id}
                                {...row.getRowProps()}
                                className={row.original.error ? "error" : ""}
                                >
                                    {row.cells.map((cell) => (
                                        <SetInfoForUpload header={cell.render("Cell").props.column.Header}
                                        _cell={cell}
                                        />
                                    ))}
                                </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <div>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"25px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"25px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"25px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </div>
            ) :
            <></>}
        </div>
    )
}
function SetInfoForUpload({header, 
    _cell, 
}) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "Photo") {
        if(data.photo){
            const imageSrc = 'data:image/jpeg;base64,' + data.photo;

            return(
                <td>
                    <img className="avatarImg" src={imageSrc} alt=""/>
                </td>
            )
        }
        return(
            <td>
                <img className="avatarImg" src="images/sample.jpg" alt=""/>
            </td>
        )
    }

    if(header === "Date Created"
    ){
        if(!value){
            return (
                <td>
                </td>
            );
        }

        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    if(header === "Error"
    ){
        return (
            <td>
                {value && (
                    <p style={{ color: "red", margin: 0 }}>
                        {value}
                    </p>
                )}
            </td>
        );
    }

    if( header === "Vacation Leave"
    || header === "Sick Leave"
    || header === "Service Incentive Leave"
    || header === "Solo Parent Leave"
    || header === "Vacation Leave Remaining"
    || header === "Sick Leave Remaining"
    || header === "Service Incentive Leave Remaining"
    || header === "Solo Parent Leave Remaining"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        let time = _cell.render("Cell").props.value;

        if(!time) {
            return (
                <td>
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }

    return (
        <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>
    )
}
function ViewLeaveDetailForm({ isOpen, onClose, leaveDetails }) {
    console.log({leaveDetails})
    var header = [
        "Reference No.",
        "Date From",
        "Date To",
        "Leave Type",
        "Days",
        "Reason",
    ];
    var accessor = [
        "referenceNumber",
        "dateFrom",
        "dateTo",
        "leaveTypeDescription",
        "days",
        "reason",
    ];

    const [currentPage, setCurrentPage] = useState(1)

    const handleClose = () => {
        onClose();
        setCurrentPage(1)
    };

    return (
        <>
        <div className={`modal-overlay ${isOpen ? "open" : ""}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                    <div className="popUp-title">
                        <h3 style={{ color: "#668fca" }}>Leave Detail</h3>
                    </div>
                    <div className="popUp-close">
                        <CloseIcon onClick={() => handleClose()} />
                    </div>
                </div>

                <div className="popUp-body loan-history-table user-template-body">
                    <div    
                        className="users-table container"
                        style={{ overflow: "unset" }}
                    >
                        <CreateTableLeaveDetail
                            dataList={leaveDetails || []}
                            dataHeader={header}
                            dataAccessor={accessor}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>
                </div>

                <div
                    className="buttons row"
                    style={{
                        justifyContent: "center",
                        padding: "40px 40px 20px 40px",
                    }}
                ></div>
            </div>
            )}
        </div>
        </>
    );
}
export function CreateTableLeaveDetail({
  dataList = [],
  dataHeader = [],
  dataAccessor = [],
  editHandleClick,
  deleteHandleClick,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const columns = React.useMemo(
    () =>
      dataHeader.map((header, index) => ({
        Header: header,
        accessor: dataAccessor[index],
      })),
    [dataHeader, dataAccessor]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: dataList });

  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
  const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
  const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(rows.length / itemsPerPage);
  const isLastPage = currentPage === totalPages;

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <table {...getTableProps()} className='border-collapse'>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {dataList.length <= 0 && (
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "center" }}>
                No data to display
              </td>
            </tr>
          )}
          {currentItems.map((row) => {
            prepareRow(row);
            return (
              <tr key={row.original.id} {...row.getRowProps()}>
                {row.cells.map((cell) =>
                  SetInfoLeaveDetail(
                    cell.render("Cell").props.column.Header,
                    cell,
                    editHandleClick,
                    deleteHandleClick
                  )
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > itemsPerPage ? (
        <>
          <div
            className="table-page row"
            style={{
              alignItems: "center",
              justifyContent: "end",
              padding: "20px 0 0 0",
            }}
          >
            <button
              className="prev row"
              onClick={() => paginate(1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              &lt;&lt;
            </button>
            <button
              className="prev row"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              style={{
                visibility: currentPage === 1 ? "hidden" : "visible",
                marginRight: "5px",
                height: "26px",
              }}
            >
              <NavigateBeforeIcon style={{ marginRight: "5px" }} /> PREVIOUS
            </button>
            <button
              className="next row"
              onClick={() => paginate(currentPage + 1)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                marginRight: "5px",
                height: "26px",
              }}
            >
              NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
            </button>
            <button
              className="next row"
              onClick={() => paginate(totalPages)}
              disabled={indexOfLastItem >= rows.length}
              style={{
                visibility:
                  rows.length > itemsPerPage && !isLastPage
                    ? "visible"
                    : "hidden",
                height: "26px",
              }}
            >
              &gt;&gt;
            </button>
          </div>
          {`${currentPage}/${totalPages}`}
        </>
      ) : (
        <></>
      )}
    </>
  );
}
function SetInfoLeaveDetail(header, _cell, editHandleClick, deleteHandleClick) {
  const data = _cell.render("Cell").props.row.original;
  const value = _cell.render("Cell").props.value;

  if (header === "") {
    return (
      <td>
        <div
          className="row"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <Tooltip text="Update">
            <div
              style={{ padding: "0 5px" }}
              onClick={() => editHandleClick(data)}
            >
              <ModeEditIcon />
            </div>
          </Tooltip>
          {deleteHandleClick ? (
            <Tooltip text="Delete">
              <div
                style={{ padding: "0 5px" }}
                onClick={() => deleteHandleClick(data)}
              >
                <DeleteForeverIcon />
              </div>
            </Tooltip>
          ) : (
            <></>
          )}
        </div>
      </td>
    );
  }

  if (header === "Reference No.") {
    const formattedNumber = value.toString().padStart(6, "0");

    if (data.requestTypeId === 1) {
      return <td>LV-{formattedNumber}</td>;
    } else if (data.requestTypeId === 2) {
      return <td>CS-{formattedNumber}</td>;
    } else if (data.requestTypeId === 3) {
      return <td>OT-{formattedNumber}</td>;
    } else if (data.requestTypeId === 4) {
      return <td>CH-{formattedNumber}</td>;
    } else if (data.requestTypeId === 5) {
      return <td>OS-{formattedNumber}</td>;
    }
  }

  if (header === "Uploaded Image") {
    if (data.content) {
      const imageSrc = "data:image/jpeg;base64," + data.content;

      return (
        <td>
          <img
            className=""
            src={imageSrc}
            alt=""
            style={{ width: "250px", height: "auto" }}
          />
        </td>
      );
    }
    return (
      <td>
        <img className="" src="" alt="" />
      </td>
    );
  }

  if (header === "Approved?") {
    return (
      <td>
        <input
          type="checkbox"
          id="overtime-allowance"
          className="checkbox"
          name=""
          checked={data.isApproved}
          disabled={true}
        />
      </td>
    );
  }

  if (
    header === "Has Allowance" ||
    header === "Is Above 2 Hours" ||
    header === "Is Half Day"
  ) {
    return <td>{value.toString()}</td>;
  }

  if (
    header === "Time From" ||
    header === "Time To" ||
    header === "Time In" ||
    header === "Time Out"
  ) {
    const time = _cell.render("Cell").props.value;
    if (!time) {
      return <td>-</td>;
    }

    let timeParts;
    let formattedTime;

    if (globalTimeFormat === "Standard Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      // Convert 24-hour format to 12-hour format and determine AM or PM
      const amPm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

      formattedTime = `${hours}:${minutes} ${amPm}`;
    } else if (globalTimeFormat === "Military Time") {
      const timeSplit = time.split("T");
      if (timeSplit.length > 1) {
        timeParts = timeSplit[1].substr(0, 5).split(":");
      } else {
        timeParts = [];
      }
      let hours = parseInt(timeParts[0], 10);
      const minutes = timeParts[1];

      formattedTime = `${hours}:${minutes}`;
    }

    return <td>{formattedTime}</td>;
  }

  if (
    header === "Date" ||
    header === "Date From" ||
    header === "Date To" ||
    header === "Date Processed" ||
    header === "Request Date" ||
    header === "Date Requested"
  ) {
    const date = new Date(_cell.render("Cell").props.value);
    if (!date) {
      return <td>-</td>;
    }

    const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
    const dd = date.getDate();
    const yyyy = date.getFullYear();

    const formattedDateFrom = `${mm}/${dd}/${yyyy}`;

    return <td>{formattedDateFrom}</td>;
  }

  //Double type data
  if (
    header === "Over Percentage" ||
    header === "Deduction" ||
    header === "Salary" ||
    header === "Employee" ||
    header === "Employer" ||
    header === "Range From" ||
    header === "Range To" ||
    header === "Monthly Salary" ||
    header === "SSS ER" ||
    header === "SSS EE" ||
    header === "SSS Total" ||
    header === "ECER" ||
    header === "Total Contribution ER" ||
    header === "Total Contribution EE" ||
    header === "Total Contribution Total" ||
    header === "SE Total Contribution" ||
    header === "Salary Range From" ||
    header === "Salary Range To" ||
    header === "Total Monthly Premium" ||
    header === "Percentage" ||
    header === "Amount" ||
    header === "Total Loan" ||
    header === "Total Balance" ||
    header === "Default Deduction" ||
    header === "Allowance" ||
    header === "Daily Salary" ||
    header === "Allowance" ||
    header === "Total Basic" ||
    header === "Rate" ||
    header === "Hours OT Regular" ||
    header === "Total OT Regular" ||
    header === "Hours OT Exceeded" ||
    header === "Total OT Exceeded" ||
    header === "Hours OT Restday" ||
    header === "Total OT Restday" ||
    header === "Hours Holiday Special" ||
    header === "Total Holiday Special" ||
    header === "Hours Holiday Regular" ||
    header === "Total Holiday Regular" ||
    header === "Hours Restday Holiday Special" ||
    header === "Total Restday Holiday Special" ||
    header === "Hours Restday Holiday Regular" ||
    header === "Total Restday Holiday Regular" ||
    header === "Additions" ||
    header === "SSS" ||
    header === "Pagibig" ||
    header === "Philhealth" ||
    header === "SSS Loan" ||
    header === "SSS Calamity Loan" ||
    header === "Pagibig Loan" ||
    header === "Pagibig Calamity Loan" ||
    header === "Tax" ||
    header === "Deductions" ||
    header === "Adjustments" ||
    header === "Total Net Pay" ||
    header === "Days Absent" ||
    header === "Absent/s" ||
    header === "Days Leave" ||
    header === "Leave/s" ||
    header === "Hours Exceeded" ||
    header === "Total Exceeded" ||
    header === "Hours Undertime" ||
    header === "Undertime" ||
    header === "Hours Late" ||
    header === "Late" ||
    header === "Night Diff" ||
    header === "OT Regular" ||
    header === "OT Restday" ||
    header === "Holiday Special" ||
    header === "Holiday Regular" ||
    header === "Restday Holiday Special" ||
    header === "Restday Holiday Regular" ||
    header === "Total Absents" ||
    header === "Total Late" ||
    header === "Total Undertime" ||
    header === "Total Leaves" ||
    header === "Total Night Diff" ||
    header === "Total Exceed" ||
    header === "Exceed" ||
    header === "Hours" ||
    header === "Days"
  ) {
    const value = _cell.render("Cell").props.value;

    // Check if value is a number
    const isNumber = typeof value === "number";

    const numberWithCommasAndDecimal = (number) => {
      return number.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    if (!isNumber) {
      return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
    }

    const formattedNumber = numberWithCommasAndDecimal(value);

    return <td>{formattedNumber}</td>;
  }

  return <td {..._cell.getCellProps()}> {_cell.render("Cell")}</td>;
}
export default TimeKeeping
